export const deMessages = {
  hostRewardsSummary: {
    SectionHeader: 'Übersicht Gastgeber-Vorteile',
    NoRewardsEarned: 'Der Gastgeber hat noch keine Vorteile verdient.',
    Earned: 'Verdient',
    EarnedLabel: 'Verdient:',
    RemainingLabel: 'Übrig:',
    FreeDollars: 'Gastgeber-Guthaben',
    PercentageOffItem: 'Rabatt-Produkte',
    PercentageOffOrder: 'Prozent-Rabatt auf die Bestellung',
    DiscountedSkuFromList: 'Rabattierte Produkte',
    DiscountedItem: 'Rabattiertes Produkt',
    SelectFreeProduct: 'Gratisprodukte',
    FreeProduct: 'Gratisprodukt',
    FreeShipping: 'Keine Versandkosten',
    Coupon: 'Gutschein',
    Other: 'Vorteil',
  },
  rma: {
    ProductReturnsTitle: 'Produktrücksendungen',
    AllProductReturns: 'Alle Produktrücksendungen',
    KeepTrackDescription: 'Behalten Sie den Überblick über alle Ihre Produktrücksendungen',
    NewProductReturn: 'Neue Produktrücksendung',
    SearchByNameOrReference: 'Nach Name oder Referenznummer suchen...',
    Filters: 'Filter',
    ReturnsWithNoTracking: 'Rücksendungen ohne Sendungsnummer',
    From: 'Von',
    ComplaintsTitle: 'Beschwerden',
    ReviewAndManage: 'Kundenbeschwerden überprüfen und verwalten',
    RecordComplaint: 'Beschwerde erfassen',
    Status: 'Status',
    SelectStatus: 'Status auswählen',
    MaxResults: 'Max. Ergebnisse',
    SelectColumn: 'Spalte',
    SelectOperator: 'Operator',
    SearchFor: 'Suchen nach',
    SearchPlaceholder: 'Suchtext eingeben...',
    Search: 'Suchen',
    Filter: 'Filter',
    FilterTitle: 'Beschwerden filtern',
    ApplyFilters: 'Filter anwenden',
    ClearFilters: 'Filter löschen',
    CloseFilters: 'Schließen',
    NoComplaintsFound: 'Keine Beschwerden für die ausgewählten Kriterien gefunden.',
    LastName: 'Nachname',
    FirstName: 'Vorname',
    Name: 'Name',
    RMANumber: 'RMA-Nummer',
    RMADetails: 'RMA-Details',
    DateOfSubmission: 'Einreichungsdatum',
    CreatedDate: 'Erstellungsdatum',
    FeeTotal: 'Gebühren gesamt',
    Total: 'Gesamt',
    TrackingNumber: 'Sendungsnummer',
    NoTrackingProvided: 'Keine Sendungsnummer angegeben',
    Showing: 'Zeige',
    To: 'bis',
    Of: 'von',
    Entries: 'Einträgen',
    Previous: 'Zurück',
    Next: 'Weiter',
    FirstPage: 'Erste Seite',
    PreviousPage: 'Vorherige Seite',
    NextPage: 'Nächste Seite',
    LastPage: 'Letzte Seite',
    Close: 'Schließen',
    ReturnStatus: 'Rücksendestatus',
    CustomerInformation: 'Kundeninformation',
    ComplaintDetails: 'Beschwerdedetails',
    ProductInformation: 'Produktinformation',
    RefundInformation: 'Rückerstattungsinformation',
    RefundAmount: 'Rückerstattungsbetrag',
    ShippingAmount: 'Versandbetrag',
    ShippingMethod: 'Versandmethode',
    AOEOrderId: 'AOE Bestellnummer',
    ClosedDate: 'Abschlussdatum',
    IsSubmitted: 'Ist eingereicht',
    ExportDate: 'Exportdatum',
    Notes: 'Notizen',
    Yes: 'Ja',
    NotAvailable: 'Nicht verfügbar',
    All: 'Alle',
    Open: 'Offen',
    WillBeShipped: 'Wird versendet',
    Closed: 'Geschlossen',
    Cancelled: 'Storniert',
    OnHold: 'In Wartestellung',
    ReturnExpected: 'Rücksendung erwartet',
    CreditDebitProcessingError: 'Fehler bei der Zahlungsverarbeitung',
    ClosedWithoutReturns: 'Ohne Rücksendung geschlossen',
    New: 'Neu',
    ManualReimbursementRequired: 'Manuelle Erstattung erforderlich',
    PhotoIsMissing: 'Foto fehlt',
    ReceiptInProcess: 'Quittung in Bearbeitung',
    ReleaseAwaited: 'Freigabe erwartet',
    StartsWith: 'Beginnt mit',
    EndsWith: 'Endet mit',
    Contains: 'Enthält',
    Equals: 'Ist gleich',
    Between: 'Zwischen',
    GreaterThan: 'Größer als',
    LessThan: 'Kleiner als',
    ItemsBeingReturned: 'Zurückgesendete Artikel',
    ReplacementItems: 'Ersatzartikel',
    Exit: 'Zurück',
    SubmitSuccess: 'Erfolg!',
    RMASubmittedSuccessfully: 'RMA {rmaNumber} wurde erfolgreich eingereicht!',
    ReturnAddress: 'Rücksendeadresse',
    NoAddressSelected: 'Keine Adresse ausgewählt',
    SelectAddress: 'Adresse auswählen',
    SelectReturnAddress: 'Rücksendeadresse auswählen',
    AddNewAddress: 'Neue Adresse hinzufügen',
    SubmitRMA: 'RMA einreichen',
    GoBack: 'Zurück',
    AddressSaved: 'Adresse gespeichert',
    AddressSaveError: 'Fehler beim Speichern der Adresse',
    RequiredAddressFields: 'Bitte füllen Sie alle erforderlichen Adressfelder aus',
    SelectReasonPlaceholder: 'Grund auswählen...',
    returnReasons: {
      DUR: 'Bruch bei Verwendung - DUR',
      DSR: 'Bruch bei Lieferung - DSR',
      EXR: 'Umtausch-Rückgabe - EXR',
    },
    errors: {
      enterOrderNumber: 'Bitte geben Sie eine Bestellnummer ein',
      enterValidOrderNumber: 'Bitte geben Sie eine gültige Bestellnummer ein',
      failedToLoadOrderDetails: 'Bestelldetails konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
      orderNotFound: 'Bestellung nicht gefunden. Bitte überprüfen Sie die Bestellnummer und versuchen Sie es erneut.',
      failedToSearchOrder: 'Bestellung konnte nicht gesucht werden. Bitte versuchen Sie es erneut.',
      orderDetailsNotFound: 'Bestelldetails nicht gefunden',
      rmaNotCreated: 'RMA wurde nicht erstellt. Bitte gehen Sie zurück und versuchen Sie es erneut.',
      failedToSubmitRMA: 'RMA konnte nicht eingereicht werden. Bitte versuchen Sie es erneut.',
      failedToUpdateRefund: 'Die Erstattungsauswahl konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
      failedToLoadPaymentMethods: 'Die verfügbaren Zahlungsmethoden konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
      selectAtLeastOneItemToReturn: 'Bitte wählen Sie mindestens einen Artikel oder eine Komponente zur Rücksendung aus',
      selectReasonForAllSelectedItems: 'Bitte wählen Sie für alle ausgewählten Artikel einen Grund aus',
      selectReasonForAllSelectedComponents: 'Bitte wählen Sie für alle ausgewählten Komponenten einen Grund aus',
      failedToCreateRMA: 'RMA konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    },
    // Order details grid
    Details: 'Details',
    Warehouse: 'Lager',
    LastUpdated: 'Zuletzt aktualisiert',
    OrderTotal: 'Bestellsumme',
    OrderType: 'Bestelltyp',
    Orders: 'Bestellungen',
    OrderNumber: 'Bestellnummer',
    OrderDate: 'Bestelldatum',
    ComplaintSubmitted: 'Beschwerde eingereicht',
    Guests: 'Gäste',
    Customer: 'Kunde',
    CustomerStatus: 'Kundenstatus',
    DeliveryAddress: 'Lieferadresse',
    EmailAddress: 'E-Mail-Adresse',
    PhoneNumber: 'Telefonnummer',
    Consultant: 'Berater',
    Advisor: 'Berater',
    GoodStanding: 'Guter Stand',
    FinancialState: 'Finanzieller Status',
    // Reason codes
    ReasonCodesTitle: 'Rückgabegründe',
    ReasonCodeDUR: 'DUR - Bruch bei Verwendung',
    ReasonCodeDURDescription: 'Das Produkt ist während der Verwendung defekt.',
    ReasonCodeDSR: 'DSR - Bruch bei Lieferung',
    ReasonCodeDSRDescription: 'Das Produkt kam beschädigt an.',
    ReasonCodePQ: 'PQR - Produktqualität',
    ReasonCodePQDescription: 'Das Produkt wurde mit einem Defekt oder Fehler geliefert.',
    ReasonCodeEX: 'EXR - Umtausch',
    ReasonCodeEXDescription: 'Umtausch gegen einen anderen Artikel.',
    ReasonCodesNote: 'Niemals werden Umtausch von Artikeln, die älter als 30 Tage sind, nicht akzeptiert. Sobald Sie Ihren Anspruch erfolgreich eingereicht haben, wird innerhalb von 48-72 Stunden ein Rücksendeetikett vom Kundenservice-Team erstellt. Sie erhalten eine separate E-Mail mit Ihrem Rücksendeetikett.',
    // Exchange item selection
    SelectExchangeItem: 'Umtauschartikel auswählen',
    SearchForProduct: 'Produkt suchen (mind. 3 Zeichen)...',
    ExchangeItemSelected: 'Umtauschartikel ausgewählt',
    RemoveExchangeItem: 'Entfernen & anderen Artikel auswählen',
    ExchangeItemRequired: 'Umtauschartikel erforderlich',
    ExchangeItemRequiredMessage: 'Bitte wählen Sie für alle zum Umtausch markierten Artikel einen Umtauschartikel aus',
    UploadPhotos: 'Fotos & Videos hochladen',
    UploadPhotosTitle: 'Fotos & Videos von Rücksendeartikel hochladen',
    UploadNewPhotos: 'Neue Fotos & Videos hochladen',
    PreviouslyUploadedPhotos: 'Zuvor hochgeladene Fotos & Videos',
    PhotoRequired: 'Erforderlich',
    PhotoRequiredMessage: 'Bitte laden Sie Fotos oder Videos für alle Artikel hoch, die diese benötigen. Achten Sie auf Artikel, die mit einem roten Sternchen (*) markiert sind.',
    SKUComponents: 'SKU-Komponenten',
    InitiateReturn: 'Rücksendung einleiten',
    EnterOrderNumber: 'Geben Sie unten Ihre Bestellnummer ein, um den Rücksendeprozess zu starten.',
    OrderNumberPlaceholder: 'Bestellnummer eingeben...',
    Searching: 'Suche läuft...',
    ExistingRMAFound: 'Bestehende RMA gefunden',
    ExistingRMAMessage: 'Für diese Bestellung wurde bereits eine RMA eingereicht.',
    ExistingRMAInfo: 'Bitte wenden Sie sich an den Kundenservice, wenn Sie Hilfe bei dieser Rücksendung benötigen.',
    SelectItemsToReturn: 'Artikel zur Rücksendung auswählen',
    SelectItemsInstruction: 'Wählen Sie die Artikel aus, die Sie zurückschicken möchten, und geben Sie für jeden einen Grund an.',
    SKU: 'SKU',
    ProductCode: 'Produktcode',
    Quantity: 'Menge',
    LineTotal: 'Zeilensumme',
    ReturnReason: 'Rückgabegrund',
    ItemsSelected: 'Artikel ausgewählt',
    ProceedWithReturn: 'Mit der Rücksendung fortfahren',
    ItemsToReceive: 'Zu empfangende Artikel',
    Totals: 'Summen',
    CreditAmount: 'Gutschriftbetrag',
    Fees: 'Gebühren',
    ReturnCreditBalance: 'Guthabensaldo der Rücksendung',
    NewPurchases: 'Neukäufe',
    BuyingDiscount: 'Einkaufsrabatt',
    RefundMethod: 'Erstattungsmethode',
    ReturnCreditRequired: 'Für diese Rücksendung steht Ihnen eine Gutschrift zu. Wählen Sie, wie diese erstattet werden soll.',
    RefundOriginalPaymentMethod: 'Erstattung auf die ursprüngliche Zahlungsmethode',
    RefundColumnName: 'Zahlung',
    RefundColumnCharge: 'Ursprünglicher Betrag',
    RefundColumnChargeNotRefunded: 'Verfügbar zur Erstattung',
    RefundColumnRefundAmount: 'Erstattungsbetrag',
    RefundRemainingToAllocate: '{amount} muss noch einer Erstattungsmethode zugewiesen werden, bevor Sie diese Rücksendung einreichen können.',
    PaymentRequired: 'Zahlung erforderlich',
    PaymentRequiredDescription: 'Für den Abschluss dieser Rücksendung ist eine zusätzliche Zahlung erforderlich. Bitte geben Sie unten eine Zahlungsmethode an.',
    BrainTreeCreditCardHeader: 'Kreditkarte',
    BrainTreePaymentAmount: 'Zahlungsbetrag',
    BrainTreeAddPayment: 'Zahlung hinzufügen',
    BankPaymentHeader: 'Mit Bankkonto bezahlen',
    BankPaymentInstruction: 'Zahlen Sie mit Ihrem Bankkonto, um den für diese Rücksendung fälligen Betrag zu begleichen.',
    BankPaymentYourBankDetails: 'Ihre Bankdaten',
    BankPaymentAccountHolder: 'Kontoinhaber',
    BankPaymentAccountNumber: 'Kontonummer',
    BankPaymentRoutingNumber: 'Bankleitzahl',
    BankPaymentAmount: 'Zahlungsbetrag',
    BankPaymentPayWithBank: 'Mit Bankkonto bezahlen',
    BankPaymentProcessing: 'Verarbeitung...',
    BankPaymentNoBankDetailsFound: 'Keine Bankdaten gefunden. Bitte fügen Sie Ihre Bankdaten hinzu, um diese Zahlungsmethode zu nutzen.',
  },
  validators: {
    requiredField: '{fieldName} ist erforderlich',
    birthDateRequired: 'Geburtsdatum ist erforderlich',
    emailRequired: 'E-Mail-Adresse ist erforderlich',
    phoneRequired: 'Telefonnummer ist erforderlich',
    passwordRequired: 'Passwort ist erforderlich',
    confirmPasswordRequired: 'Passwort bestätigen ist erforderlich',
    passwordMismatch: 'Passwörter stimmen nicht überein',
    emailField: '{fieldName} ist eine ungültige E-Mail-Adresse',
    nameField: '{fieldName} darf nur Buchstaben, Leerzeichen, Bindestriche und Apostrophe enthalten',
    fieldLength: '{fieldName} sollte höchstens {maximumLength} Zeichen lang sein.',
    fieldMinLength: '{fieldName} muss mindestens {minimumLength} Zeichen lang sein.',
    nameMinLength: '{fieldName} muss mindestens {minimumLength} Zeichen lang sein.',
    nameMaxLength: '{fieldName} darf höchstens {maximumLength} Zeichen lang sein.',
    streetField: '{fieldName} darf nur Buchstaben, Leerzeichen, Bindestriche und Apostrophe enthalten (keine Zahlen oder Sonderzeichen)',
    houseNumberField: '{fieldName} muss mit einer Zahl beginnen und kann optional einen Buchstaben enthalten (z.B. 12A)',
    cityField: '{fieldName} darf nur Buchstaben, Leerzeichen, Bindestriche und Apostrophe enthalten',
    cityMaxLength: '{fieldName} darf höchstens {maximumLength} Zeichen lang sein',
    streetMinLength: '{fieldName} muss mindestens {minimumLength} Zeichen lang sein',
    streetMaxLength: '{fieldName} darf höchstens {maximumLength} Zeichen lang sein',
    houseNumberMinLength: '{fieldName} muss mindestens {minimumLength} Zeichen lang sein',
    houseNumberMaxLength: '{fieldName} darf höchstens {maximumLength} Zeichen lang sein',
    houseNumberFormat: '{fieldName} muss mit einer Ziffer beginnen (z.B. 12, 12A, 12/3 oder 12-14)',
    nameAddressField: '{fieldName} darf nur Buchstaben, Leerzeichen, Bindestriche und Apostrophe enthalten',
    nameAddressMinLength: '{fieldName} muss mindestens {minimumLength} Zeichen lang sein',
    nameAddressMaxLength: '{fieldName} darf höchstens {maximumLength} Zeichen lang sein',
    formatField: '{fieldName} hat ein ungültiges Format.',
    phoneNumericOnly: '{fieldName} darf nur Zahlen enthalten (keine Leerzeichen oder Symbole)',
    phoneLengthInvalid: '{fieldName} muss {min}-{max} Ziffern haben',
    postalCodeLength: '{fieldName} muss {requiredLength} Ziffern für das ausgewählte Land haben',
    passwordPattern: '<div>Passwort muss die Mindestanforderungen erfüllen:<br/><ul><li>Ein Kleinbuchstabe</li><li>Ein Großbuchstabe</li><li>Eine Zahl</li><li>Mindestens ein Sonderzeichen (&#64;$!%*?&)</li><li>Mindestens 8 Zeichen</li></ul></div>',
    passwordProhibitedChar: 'Bitte verwenden Sie nur folgende Sonderzeichen: {allowedChars}',
    minimumAge: 'Sie müssen mindestens 18 Jahre alt sein, um fortzufahren.',
    businessNameRequired: 'Sie müssen Ihren Firmennamen aktualisieren, um fortzufahren',
    directDepositRequired: 'Direkteinzahlung ist erforderlich',
    authorizedToWorkRequired: 'Sie müssen bestätigen, dass Sie in Frankreich arbeiten dürfen',
    siretWarning: 'Pampered Chef kann keine Provisionen auszahlen, bis eine SIRET-Nummer angegeben wurde.',
    contractAgreementRequired: 'Sie müssen die Geschäftspraktiken und den Ethikkodex akzeptieren, um fortzufahren',
    vatNumberFormat: 'Die französische Umsatzsteuer-Identifikationsnummer muss mit FR gefolgt von 11 Zeichen beginnen (z.B. FR12345678901)',
    vatNumberFormatATDE: 'Die Umsatzsteuer-Identifikationsnummer muss im deutschen Format (DE + 9 Ziffern) oder österreichischen Format (ATU + 8 Ziffern) sein',
    ibanFormat: 'IBAN-Format ist ungültig. Bitte überprüfen Sie den Ländercode und die Länge.',
    ibanFormatFR: 'Französische IBAN muss 27 Zeichen lang sein (FR + 25 Ziffern)',
    ibanFormatDE: 'Deutsche IBAN muss 22 Zeichen lang sein (DE + 20 Ziffern)',
    ibanFormatAT: 'Österreichische IBAN muss 20 Zeichen lang sein (AT + 18 Ziffern)',
    bicFormat: 'BIC muss 8 oder 11 Zeichen lang sein mit gültigem Ländercode',
    consultantEmailNotAllowed: 'Diese E-Mail-Adresse ist bereits mit einem Beraterkonto verknüpft und kann nicht für den Kit-Checkout verwendet werden.',
    consultantOwnEmailNotAllowed: 'Dies ist Ihre eigene E-Mail-Adresse. Bitte geben Sie die E-Mail-Adresse der Kundin bzw. des Kunden ein.',
  },
  errors: {
    loadingCountryCode: 'Fehler beim Laden der Länderinformationen. Bitte versuchen Sie es erneut.',
    savingBankDetails: 'Fehler beim Speichern der Bankdaten. Bitte versuchen Sie es erneut.',
    updatingBusinessName: 'Fehler beim Aktualisieren des Firmennamens. Bitte versuchen Sie es erneut.',
    businessNameAlreadyExists: 'Der Firmenname existiert bereits. Bitte wählen Sie einen anderen.',
    savingFrenchContribution: 'Fehler beim Speichern der französischen Beitragsinformationen. Bitte versuchen Sie es erneut.',
    loadingFrenchContribution: 'Fehler beim Laden der französischen Beitragsinformationen. Bitte versuchen Sie es erneut.',
    governmentIdInvalid: 'Die angegebene SSN- oder SIRET-Nummer ist ungültig. Bitte überprüfen und korrigieren Sie Ihre Angaben.',
    loadingContractTerms: 'Fehler beim Laden der Vertragsbedingungen. Bitte versuchen Sie es erneut.',
    savingContractAgreement: 'Fehler beim Speichern der Vertragsvereinbarung. Bitte versuchen Sie es erneut.',
    savingVatInformation: 'Fehler beim Speichern der Umsatzsteuerinformationen. Bitte versuchen Sie es erneut.',
    loadingVatInformation: 'Fehler beim Laden der Umsatzsteuerinformationen. Bitte versuchen Sie es erneut.',
    wizardCompletionFailed: 'Fehler bei der Registrierung des Assistentenabschlusses. Ihr Konto wurde eingerichtet, aber es gab ein Problem mit dem letzten Schritt.',
    wizardCompletionRetry: 'Die Einrichtung Ihres Kontos konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut, um diesen letzten Schritt abzuschließen.',
    userNotAuthenticatedOrInvalidBeeNumber: 'Benutzer nicht authentifiziert oder ungültige BEE-Nummer',
    userNotAuthenticatedOrInvalidBusinessGuid: 'Benutzer nicht authentifiziert oder ungültige Business-GUID',
    failedToSaveBankDetails: 'Fehler beim Speichern der Bankdaten',
    failedToSaveFrenchContributionData: 'Fehler beim Speichern der französischen Beitragsdaten',
    unableToGetAuthenticatedUserBeeNumber: 'BEE-Nummer des authentifizierten Benutzers konnte nicht abgerufen werden',
    noShippingAddressFoundInAddressBookEntry: 'Keine Versandadresse im Adressbucheintrag gefunden',
    noAddressBookEntryFoundForHostEmail: 'Kein Adressbucheintrag für Gastgeber-E-Mail gefunden',
    unableToGetBeeNumber: 'BEE-Nummer konnte nicht abgerufen werden',
    noReportIdSpecified: 'Keine Berichts-ID angegeben',
    noConsultantDataReceived: 'Keine Beraterdaten erhalten',
    invoiceIsCanceled: 'Rechnung ist storniert',
    missingBeeNumberToken: 'Token zur E-Mail-Verifizierung fehlt.',
  },
  messages: {
    bankDetailsSaved: 'Ihre Bankdaten wurden erfolgreich gespeichert.',
    wizardCompleted: 'Kontoeinrichtung erfolgreich abgeschlossen!',
    businessNameUpdated: 'Ihr Firmenname wurde erfolgreich aktualisiert.',
    frenchContributionSaved: 'Ihre französischen Beitragsinformationen wurden erfolgreich gespeichert.',
    contractAgreementSaved: 'Ihre Vertragsvereinbarung wurde erfolgreich gespeichert.',
    vatInformationSaved: 'Ihre Umsatzsteuerinformationen wurden erfolgreich gespeichert.',
    emailAddressVerified: 'Vielen Dank, dass Sie Ihre E-Mail-Adresse verifiziert haben.',
  },
  actions: {
    Save: 'Speichern',
    TryAgain: 'Erneut versuchen',
    UpdateBusinessName: 'Firmennamen aktualisieren',
    AcceptAndContinue: 'Akzeptieren und fortfahren',
  },
  security_question_1: 'Was war Ihr Spitzname als Kind?',
  security_question_2: 'In welcher Stadt oder welchem Ort haben Sie Ihren Ehepartner/Partner kennengelernt?',
  security_question_3: 'Wie heißt Ihr bester Freund aus der Kindheit?',
  security_question_4: 'In welcher Straße haben Sie in der dritten Klasse gewohnt?',
  security_question_5: 'Was ist der Geburtsmonat und das Geburtsjahr Ihres ältesten Geschwisterteils? (z.B. Januar 1970)',
  security_question_6: 'Wie lautet der zweite Vorname Ihres jüngsten Kindes?',
  security_question_7: 'Wie lautet der zweite Vorname Ihres ältesten Geschwisterteils?',
  security_question_8: 'Welche Schule haben Sie in der sechsten Klasse besucht?',
  security_question_9: 'Wie hieß Ihr erstes Stofftier?',
  security_question_10: 'In welcher Stadt oder welchem Ort haben sich Ihre Mutter und Ihr Vater kennengelernt?',
  routes: {
    CountryList: 'Länderliste',
    CountryEdit: 'Länder bearbeiten',
    DocumentTemplateList: 'Dokumentvorlagenliste',
    DocumentTemplateEdit: 'Dokumentvorlage bearbeiten',
    DocumentTemplateCultureSpecificList:
      'Kulturspezifische Dokumentvorlagenliste',
    DocumentTemplateCultureSpecificEdit:
      'Kulturspezifische Dokumentvorlage bearbeiten',
    Home: 'Startseite',
    Logout: 'Abmelden',
    LocaleChanger: 'Sprachwechsler',
    Setup: 'Einrichtung',
    StateList: 'Staatenliste',
    StateEdit: 'Staat bearbeiten',
    Welcome: 'Willkommen',
    Checkout22: 'Kasse 21',
  },
  address: {
    AddressLines: 'Adresse',
    SocialMedia: 'Soziale Medien',
    Communication: 'Kommunikation',
    PhoneCountry: 'Land',
    Name: 'Vorname und Nachname',
    NameRequired: 'Felder mit * bitte ausfüllen.',
    PostalCode: 'Postleitzahl',
    State: 'Bundesland/Provinz',
    Street2: 'Adresszeile 2',
    HouseNumber: 'Hausnummer',
    Street: 'Straße',
    Country: 'Land',
    City: 'Stadt',
  },
  buttons: {
    Edit: 'Bearbeiten',
    Delete: 'Löschen',
    Yes: 'Ja',
    No: 'Nein',
    Add: 'Hinzufügen',
    Filter: 'Filter',
    Clear: 'Löschen',
    Apply: 'Anwenden',
    Save: 'Speichern',
    Exit: 'Beenden',
    StateList: 'Staatenliste',
    DocumentTemplateCultureSpecificList:
      'Kulturspezifische Dokumentvorlagenliste',
    Html: 'Html',
    Raw: 'Roh',
    CareerPlan: 'Karriereplan',
    MyParties: 'Meine Partys',
    TrainingVideos: 'Schulungsvideos',
    MyTeam: 'Teamübersicht',
    UseCoupon: 'Gutschein verwenden',
    ApplyCoupon: 'Gutschein anwenden',
    RemoveCoupon: 'Gutschein entfernen ({0})',
    Okay: 'Okay',
    Back: 'Zurück',
    Cancel: 'Abbrechen',
    Close: 'Schließen',
    Submit: 'Absenden',
  },
  accessibility: {
    required: 'erforderlich',
  },
  labels: {
    SearchForProduct: 'Verwende Produktname, SKU oder Schlüsselwort für die Suche',
    options: {
      Show10: 'Zeige 10',
      Show15: 'Zeige 15',
      Show20: 'Zeige 20',
    },
    Dash: '-',
    Actions: 'Aktionen',
    AddToCart: 'In den Warenkorb',
    BecomeAConsultant: 'Interesse an einer Beratertätigkeit',
    Cancel: 'Abbrechen',
    Confirm: 'Bestätigen',
    VatInformationHeader: 'Umsatzsteuerinformationen',
    VatInformationSubHeader: 'Bitte geben Sie Ihre Umsatzsteuerinformationen an, um Ihre Registrierung abzuschließen',
    VatType: 'Umsatzsteuer-ID-Typ',
    VatNumber: 'Umsatzsteuer-ID',
    VatNumberPlaceholder: 'Geben Sie Ihre Umsatzsteuer-ID ein (z.B. FR12345678901)',
    VatNumberPlaceholderATDE: 'Geben Sie Ihre Umsatzsteuer-ID ein (z.B. DE123456789 oder ATU12345678)',
    VatNumberPlaceholderDE: 'Geben Sie Ihre Umsatzsteuer-ID ein (z.B. DE123456789)',
    VatNumberPlaceholderAT: 'Geben Sie Ihre Umsatzsteuer-ID ein (z.B. ATU12345678)',
    VatNumberHelp: 'Die Umsatzsteuer-ID muss mit FR gefolgt von 11 Zeichen beginnen',
    TaxIdNoInputRequired: 'Keine Eingabe erforderlich für TAXID',
    LoadingVatInformation: 'Umsatzsteuerinformationen werden geladen...',
    ContractAgreementHeader: 'Beratervertragsvereinbarung',
    ContractAgreementSubHeader: 'Bitte überprüfen Sie die Geschäftspraktiken und den Ethikkodex unten, bevor Sie fortfahren',
    LoadingContractTerms: 'Vertragsbedingungen werden geladen...',
    NoContractTerms: 'Keine Vertragsbedingungen verfügbar',
    Success: 'Erfolg',
    Saving: 'Speichern...',
    Updating: 'Aktualisieren...',
    CheckingInventory: 'Lagerbestand prüfen...',
    InStock: 'Auf Lager',
    SelectOption: 'Option auswählen',
    SelectValue: 'Wählen Sie einen Wert',
    PricePerUnitWeight: {
      Weight: '{0} g',
      PricePerUnit: '({0}/kg)',
    },
    MonthToDate: 'Monat bis heute',
    YearToDate: 'Jahr bis heute',
    CustomRange: 'Benutzerdefinierter Bereich',
    BusinessInfoHeader: 'Geschäftsinformationen',
    BusinessInfoSubHeader: 'Bitte geben Sie Ihre Geschäftsinformationen an, um Ihre Registrierung abzuschließen',
    BusinessName: 'Firmenname',
    FrenchContributionHeader: 'Französische Beitragsinformationen',
    FrenchContributionSubHeader: 'Bitte geben Sie die erforderlichen Informationen für die französische Gerichtsbarkeit an',
    EmployeeStatus: 'Beschäftigungsstatus',
    SSN: 'Sozialversicherungsnummer',
    SSNPlaceholder: 'Geben Sie Ihre 15-stellige Sozialversicherungsnummer ein',
    SIRET: 'SIRET-Nummer',
    SIRETPlaceholder: 'Geben Sie Ihre SIRET-Nummer ein',
    BirthCity: 'Geburtsstadt',
    BirthCityPlaceholder: 'Geben Sie Ihre Geburtsstadt ein',
    BirthCountry: 'Geburtsland',
    FrenchCitizen: 'Ich bin französischer Staatsbürger',
    AuthorizedToWork: 'Ich bin berechtigt, in Frankreich zu arbeiten',
    LoadingFrenchContribution: 'Laden der französischen Beitragsinformationen...',
    BusinessNamePlaceholder: 'Geben Sie Ihren Firmennamen ein',
    PersonalURL: 'URL Ihrer persönlichen Website',
    NewUserWizardHeader: 'Willkommen bei der Einrichtung Ihres Kontos',
    NewUserWizardSubHeader: 'Bitte führen Sie die folgenden Schritte aus, um Ihr Konto einzurichten',
    BankDetailsHeader: 'Bankinformationen',
    BankDetailsSubHeader: 'Bitte geben Sie Ihre Bankdaten ein, um Provisionszahlungen zu erhalten',
    BankAccountType: 'Bankkontoart',
    BankName: 'Bankname',
    BankNamePlaceholder: 'Geben Sie Ihren Banknamen ein',
    BIC: 'BIC (Bankleitzahl)',
    BICPlaceholder: 'Geben Sie Ihren BIC-Code ein',
    IBAN: 'IBAN',
    IBANPlaceholder: 'Geben Sie Ihre IBAN ein',
    DirectDeposit: 'Ich autorisiere die Direkteinzahlung für Provisionszahlungen',
    OPA: 'OPA (Optional)',
    LoadingBankDetails: 'Bankinformationen werden geladen...',
    ExitImageOverlay: 'Klicken Sie auf das Bild, um es zu verkleinern',
    Filter: 'Filter',
    GridNoRecords: 'Keine Einträge gefunden',
    Search: 'Suche',
    Language: 'Sprache',
    ChooseLanguage: 'Sprache auswählen',
    ChooseCountry: 'Wählen Sie Ihr Land',
    SearchKeyword: 'Nach Schlüsselwort suchen',
    ShowMore: 'Mehr Ergebnisse anzeigen',
    ShowLess: 'Weniger anzeigen',
    NoResultsFound: 'Keine Ergebnisse gefunden',
    View: 'Ansehen',
    Logout: 'Abmelden',
    Okay: 'Okay',
    Error: 'Fehler',
    Loading: 'Laden',
    SkuPrefix: 'SKU: {sku}',
    DropDownListPlaceholder: 'Wählen Sie ein {value}',
    CardHolderName: 'Name des Karteninhabers',
    CardNumber: 'Kartennummer',
    CardExpirationDate: 'Ablaufdatum',
    CardSecurityCode: 'CVV',
    EmailMoreInfoCheckbox: 'Ich möchte E-Mails über Produkte, Rezepte, Sonderangebote und Verkäufe erhalten.',
    CheckoutContinue: 'Weiter',
    CheckoutPlaceOrder: 'Bestellung aufgeben',
    NewCheckoutPlaceOrder: 'JETZT KAUFPFLICHTIG BESTELLEN',
    CheckoutUseSelectedAddress: 'Ausgewählte Adresse verwenden',
    CheckoutReEnterAddress: 'Adresse erneut eingeben',
    SameAsBillingCheckbox: 'Diese Adresse als meine Rechnungsadresse verwenden',
    FreeProductQuantityPrefix: '{quantity}x ',
    MarketingOptIn_NEWSLETTER_Content: '<span class="marketingconent"><p>Ich möchte zukünftig über Trends, Schnäppchen, Gutscheine, Aktionen und Angebote der Pampered Chef Österreich per E-Mail informiert werden.</p><br>    <p>Deine Einwilligung zu diesen Aktivitäten kannst du jederzeit und kostenlos widerrufen. Weitere Informationen darüber, wie wir deine personenbezogenen Daten verarbeiten und wie du deine Zustimmung widerrufen kannst, findest du in unserer Datenschutzerklärung</p></span>',
    MarketingOptIn_MARKETING_Content:  '<span class="marketingconent"><p>Ich möchte zukünftig über Trends, Schnäppchen, Gutscheine, Aktionen und Angebote der Pampered Chef Österreich per E-Mail informiert werden.</p><br>    <p>Deine Einwilligung zu diesen Aktivitäten kannst du jederzeit und kostenlos widerrufen. Weitere Informationen darüber, wie wir deine personenbezogenen Daten verarbeiten und wie du deine Zustimmung widerrufen kannst, findest du in unserer Datenschutzerklärung</p></span>',
    Country: 'Land',
    BirthDate: 'Geburtsdatum',
    RegistrationHeader: 'Konto erstellen',
    CreateAccount: 'Konto erstellen',
    MarketingOptIn: 'Datenverarbeitung zu Werbezwecken',
  },
  cart: {
    CartHeader: 'Ihr Warenkorb',
    ApplePayCheckout: 'Bezahlen mit',
    ApplePayImageAlt: 'Apple Pay',
    Select: 'Auswählen',
    Checkout: 'Kasse',
    CompleteSet: 'Vervollständigen Sie Ihr Set',
    ConnectHeader: 'Finde einen Berater in deiner Nähe',
    ConnectSubHeader: 'Noch keinen passenden Berater gefunden? Wir helfen dir, einen in deiner Nähe zu finden.',
    ConsultantByName: 'Nach Name',
    ConsultantByLocation: 'Nach Standort',
    ConsultantListHeader: 'Berater in Ihrer Nähe',
    ContinueShopping: 'WEITER EINKAUFEN',
    FindConsultatHeader: 'Finden Sie einen Berater',
    FindConsultatSubHeader: 'Geben Sie den Vor- und Nachnamen Ihres Beraters ein oder suchen Sie nach einem Berater in Ihrer Nähe.',
    FindParty: 'FINDEN SIE EINE PARTY',
    FindPartyHeader: 'Finden Sie eine Party',
    FindPartyConsultant: 'FINDEN SIE EINEN BERATER',
    FindPartySubHeader: 'Suche gezielt nach Kochshownummer oder Gastgebername.',
    GuestCheckout: 'Gast Checkout',
    GuestCheckoutSubHeader: 'Sie können als Gast auschecken und später ein Konto erstellen.',
    HostedBy: 'Gastgeber',
    InterestedInHosting: 'Interessiert an der Ausrichtung einer Party?',
    InterestedInHostingLink: 'Erfahren Sie mehr',
    NoFreeGift: 'Nein danke, ich möchte kein kostenloses Geschenk',
    NotOrderWithConsultant: 'Ich bestelle nicht mit einem Berater',
    NotSupported: 'Nicht unterstützt',
    OrderingWith: 'Sie bestellen mit',
    OrderSummary: 'Bestellübersicht',
    PlaceHolderConsultantName: 'Beratername eingeben',
    PlaceHolderHost: 'Suche gezielt nach Kochshownummer oder Gastgebername.',
    PlaceholderZipcode: 'Postleitzahl eingeben',
    RelatedProducts: 'Produkte, die Ihnen gefallen könnten',
    RemoveParty: 'Party entfernen',
    RemoveConsultant: 'Berater entfernen',
    SelectButton: 'Auswählen',
    SelectedFreeGift: 'Ausgewählt',
    Shipping: 'Versand',
    SignIn: 'Anmelden',
    SignInSubHeader: 'Bitte melden Sie sich für einen schnelleren Checkout an und um Ihre Rabatte und/oder Gutschriften anzuwenden.',
    Subtotal: 'Zwischensumme',
    SystemKeyword: 'Systemschlüsselwort',
    TaxCalc: 'Steuer wird beim Checkout berechnet',
    Total: 'Gesamtsumme inkl. MwSt.',
    ProductTotal: 'Gesamt',
    DiscountTotal: 'Rabatt',
    UnderParty: 'Unter',
    ViewCart: 'Warenkorb anzeigen',
    WhereParty: 'Wo',
    MustSelectPartyOrConsultant: 'Sie müssen eine Party oder einen Berater auswählen, um fortzufahren.',
    MustSelectFreeProductOrOptOut: 'Bitte wählen Sie Ihr kostenloses Produkt aus oder lehnen Sie es ab, bevor Sie fortfahren.',
    ShowFreeGift: 'Kostenlose Geschenke anzeigen',
    EmptyCart: 'Dein Warenkorb ist leer.',
    EmptyCartMessage: 'Deine Artikel erscheinen hier, sobald sie im Warenkorb sind.',
    CloseCart: 'Warenkorb schließen',
    ProductImageAlt: 'Produktbild',
    NestedImageAlt: 'Zusätzliches Produktbild',
    ViewNestedImage: 'Größeres Bild für {skuName} anzeigen',
    LegalWarrantyNotice: 'Gesetzliche Gewährleistung',
    ConsultantPhotoAlt: 'Foto des Beraters',
    ConsultantEmailAlt: 'E-Mail-Adresse des Beraters',
    ConsultantPhoneAlt: 'Telefonnummer des Beraters',
    ConsultantMobileAlt: 'Handynummer des Beraters',
    RemoveFromCart: 'Aus dem Warenkorb entfernen',
    ItemRemovedFromCart: "'{skuName}' wurde aus Ihrem Warenkorb entfernt.",
    warnings: {
      RESTRICTED_ITEM_SHIPPING: "SKU '{SkuCode}' ist für die ausgewählte Versandmethode nicht verfügbar",
      RESTRICTED_ITEM: 'Einige Artikel in Ihrem Warenkorb haben Einschränkungen.',
      INVALID_SHIPPING_METHOD: 'Die gewählte Versandart ist für Ihre Adresse nicht verfügbar.',
      MINIMUM_ORDER_NOT_MET: 'Ihre Bestellung erfüllt nicht den Mindestbestellwert.',
      SkuShippingRestriction: "SKU '{SkuCode}' ist für die ausgewählte Versandmethode nicht verfügbar",
      SkuNoLongerAvailable: "'{SkuName}' wurde aus Ihrem Warenkorb entfernt, da es nicht mehr verfügbar ist.",
      SkuNotAvailableForShippingCountry: "'{SkuName}' wurde aus Ihrem Warenkorb entfernt, da es im Lieferland nicht verfügbar ist.",
    },
  },
  checkout: {
    AddressRequirementMessage: 'Felder mit * bitte ausfüllen.',
    BillingAddressHeader: 'Rechnungsadresse',
    Checkout: 'Kasse',
    KitCheckout: 'Anmeldung abschließen',
    CheckoutAddressValAddressEntered: 'Eingegebene Adresse:',
    CheckoutAddressValHdr: 'Wir konnten die eingegebene Adresse nicht verifizieren.',
    CheckoutAddressValSubHdr: 'Bitte wählen Sie eine Adresse aus der Liste unten aus oder bearbeiten Sie Ihre Adresse.',
    CheckoutAddressValVerifiedAddress: 'Verifizierte Adressoptionen:',
    CheckoutAddressValWarning: 'Sie müssen eine verifizierte Adresse auswählen, um fortzufahren.',
    CheckoutAddressValError: 'Adresse konnte nicht verifiziert werden. Bitte geben Sie Ihre Adresse erneut ein oder fahren Sie mit der eingegebenen Adresse fort.',
    CheckoutEditStep: 'Bearbeiten',
    CheckoutPaymentHdrStep: '3. Zahlung',
    CheckoutOrderSummaryHdr: 'Bestellübersicht',
    CheckoutShipping: 'Versand',
    CheckoutShippingHdrStep: '2. Versand',
    CheckoutSubHeader: 'Melden Sie sich für einen schnelleren Checkout an und um Ihre Rabatte und/oder Gutschriften anzuwenden.',
    CheckoutSubHeaderRemainder: 'für einen schnelleren Checkout an und um Ihre Rabatte und/oder Gutschriften anzuwenden.',
    CheckoutSubtotal: 'Zwischensumme',
    CheckoutTax: 'Steuer',
    CheckoutTotal: 'Gesamtsumme inkl. MwSt.',
    CheckoutTotalRegularPrice: 'Regulärer Gesamtpreis',
    PaymentAmount: 'Zahlungsbetrag',
    CheckoutYourInformationHdrStep: '1. Ihre Informationen',
    CreditCartHeader: 'Kreditkarteninformationen',
    CreditCartSubmit: 'Absenden',
    OrderSummaryYourOrder:'Ihre Bestellung',
    OrderSummaryItem: 'Artikel',
    NotSuppoted: 'wird nicht unterstützt',
    OrderNumber: 'Bestellnummer',
    Quantity: 'Menge',
    paymentMethods: {
      TTGBraintree: 'Kreditkarte',
      TTGBraintreeAPM: 'EPS',
      TTGBraintreeFR: 'Kreditkarte',
      TTGBraintreeAT: 'Kreditkarte',
      TTGBraintreeDE: 'Kreditkarte',
      OPA: 'OPA',
      PayPal: 'PayPal',
      EPS: 'EPS',
    },
    transactionStates: {
      NotProcessed: 'Autorisiert',
      PreAuthorized: 'Vorautorisiert',
      Authorized: 'Autorisiert',
      Booked: 'Gebucht',
      Refunded: 'Erstattet',
      Processed: 'Verarbeitet',
    },
  },
  eventList: {
    AddHost: 'Gastgeber hinzufügen',
    AtHostAddress: 'Bei Gastgeberadresse',
    AtNewAddress: 'Bei anderer Adresse',
    CancelButton: 'Abbrechen',
    PreviousButton: 'Zurück',
    ClosedEventButton: 'Geschlossen',
    CreateEventButton: 'Event erstellen',
    CreateNewEvents: 'Neues Event erstellen',
    EmailAddress: 'E-Mail-Adresse',
    EventAddressError: 'Event-Adresse ist erforderlich',
    EventCommission: 'Provision',
    EventConsultantError: 'Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an',
    EventDate: 'Datum',
    EventDateError: 'Event-Datum ist erforderlich',
    EventTimeError: 'Startzeit kann nicht nach Endzeit liegen',
    EventPastDateError: 'Event kann nicht in der Vergangenheit geplant werden',
    EventHostAddError: 'Vorname, Nachname, E-Mail und Telefonnummer des Gastgebers sind erforderlich',
    HostInfoError: 'Bitte füllen Sie Gastgeber-Vorname, -Nachname und entweder Telefon oder E-Mail aus',
    HostAddressError: 'Bitte füllen Sie alle Gastgeber-Adressfelder aus',
    EventHostess: 'Gastgeber',
    EventId: 'Ereignis',
    EventLocation: 'Ort',
    EventEndTime: 'Ende',
    EventStartTime: 'Start',
    EventTitle: 'Name',
    EventTitleError: 'Event-Name ist erforderlich',
    EventTotal: 'Gesamt',
    FindHost: 'Gastgeber finden',
    FindHostError: 'Bitte wählen Sie einen Gastgeber aus',
    FirstName: 'Vorname',
    HostAddress: 'Gastgeberadresse',
    HostInformation: 'Gastgeberinformationen',
    IAmHost: 'Ich bin der Gastgeber',
    LastName: 'Nachname',
    MyEvents: 'Meine Events',
    NewEventButton: 'Neues Event',
    NewEventStep1: 'Schritt 1: Wählen Sie die Art des Events, das Sie erstellen möchten',
    NewEventStep2: 'Schritt 2: Wählen Sie das Land, in dem das Event stattfinden wird',
    NewEventStep3: 'Schritt 3: Wählen Sie den Gastgeber des Events',
    NewEventStep4: 'Schritt 4: Wählen Sie Titel und Zeit des Events',
    NewEventStep5: 'Schritt 5: Wählen Sie den Ort des Events',
    NewEventStep6: 'Was möchten Sie als Nächstes tun?',
    SaveAndFinish: 'Speichern und beenden',
    SaveAndFinishDescription: 'Speichern Sie das Event in Ihrem Kalender und kehren Sie zu Ihrer Kontoseite zurück.',
    HostPortal: 'Gastgeber-Portal',
    HostPortalDescription: 'Speichern Sie das Event und gehen Sie zum Gastgeber-Portal. Wählen Sie ein Thema und senden Sie dem Gastgeber eine E-Mail mit Zugangsdaten.',
    InviteGuests: 'Gäste einladen',
    InviteGuestsDescription: 'Speichern Sie das Event und gehen Sie zur Gästeverwaltung, um Gäste zum Event hinzuzufügen.',
    NextButton: 'Weiter',
    OpenEventButton: 'Offen',
    PhoneNumber: 'Telefonnummer',
    SearchButton: 'Suchen',
    SearchHost: 'Durchsuchen Sie Ihr Adressbuch nach Vorname, Nachname, E-Mail oder Telefonnummer',
    EventStatus: 'Status',
    SearchEvents: 'Events nach Name, ID oder Gastgeber durchsuchen...',
    ClearSearch: 'Suche löschen',
    NoEventsFound: 'Keine Events gefunden',
  },
  contactClasses: {
    Consultant: 'Berater',
    Customer: 'Kunde',
  },
  eventTypes: {
    Party: 'Party',
    InPersonEvent: 'Präsenz-Event',
    FacebookParty: 'Facebook-Party',
    WhatsAppParty: 'WhatsApp-Party',
    Unknown: 'Unbekannt',
  },
  invoice: {
    CartNumber: 'Warenkorbsnummer',
    Name: 'Name',
    Email: 'E-Mail',
    Phone: 'Telefon',
    EventName: 'Veranstaltungsname',
    InvoiceHeader: 'Rechnungszahlung',
    InvoiceInstruction: 'Bezahlen Sie die verbleibende Rechnung für Ihre Bestellung. <br/>Überprüfen Sie Ihre Rechnung unten und verwenden Sie die Schaltfläche Zahlung hinzufügen, um eine Zahlungsmethode auszuwählen.',
    InvoiceNumber: 'Rechnungsnummer',
    OrderDate: 'Bestelldatum',
    OrderInformation: 'Bestellinformationen',
    OrderReference: 'Bestellreferenz',
    ShippingAddress: 'Lieferadresse',
    SubmitButton: 'Zahlung einreichen',
    NewSubmitButton: 'JETZT KAUFPFLICHTIG BESTELLEN',
    EmailLabel: 'E-Mail-Adresse',
    EmailPlaceholder: 'Geben Sie Ihre E-Mail-Adresse ein',
    VerifyIdentityButton: 'Identität überprüfen',
    InvoiceNotFound: 'Rechnung nicht gefunden. Bitte überprüfen Sie die Rechnungsnummer und versuchen Sie es erneut.',
    VerifyIdentityInstruction: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um Ihre Identität zu überprüfen und auf diese Rechnung zuzugreifen.',
    VerifyIdentityFailed: 'Die E-Mail-Adresse stimmt nicht mit unseren Aufzeichnungen überein. Bitte versuchen Sie es erneut.'
  },
  payment: {
    CreateInvoiceButton: 'Rechnung {0} {1}',
    InvoiceHeader: 'Eine Rechnung senden',
    InvoiceIssueDate: 'Ausstellungsdatum',
    InvoiceNumber: 'Rechnungsnummer',
    InvoiceStatus: 'Rechnungsstatus',
    InvoicePaymentEntry: 'Senden Sie eine Rechnung an {0} {1}, um die Zahlung einzuziehen. Dem Kunden werden zum Zeitpunkt der Zahlung mehrere Zahlungsoptionen angeboten.',
    ResendInvoiceButton: 'Rechnung erneut an {0} {1} senden',
    BankPaymentHeader: 'Mit Bankkonto bezahlen',
    BankPaymentEntry: 'Zahlen Sie mit Ihrem Bankkonto, {0} {1}.',
    YourBankDetails: 'Ihre Bankdaten',
    AccountHolder: 'Kontoinhaber',
    AccountNumber: 'Kontonummer',
    RoutingNumber: 'Bankleitzahl',
    PaymentAmount: 'Zahlungsbetrag',
    PayWithBank: 'Mit Bankkonto bezahlen',
    Processing: 'Verarbeitung...',
    NoBankDetailsFound: 'Keine Bankdaten gefunden. Bitte fügen Sie Ihre Bankdaten hinzu, um diese Zahlungsmethode zu nutzen.',
  },
  productReview: {
    AddReviewButton: 'Bewertung hinzufügen',
    EditReviewButton: 'Bewertung bearbeiten',
    CompleteHeader: 'Danke!',
    CompleteSubHeader: 'Ihre Bewertung wurde eingereicht und wird nach der Genehmigung veröffentlicht.',
    ResendInvoice: 'Rechnung erneut senden',
    Resend: 'Erneut senden',
    CreateReview: 'Bewertung erstellen',
    ErrorHeader: 'Fehler!',
    ErrorFileSize: 'Bitte überprüfen Sie die Größe der angehängten Dateien, sie könnten zu groß sein.',
    ErrorLoggedIn: 'Sie müssen eingeloggt sein, um eine Bewertung zu erstellen',
    ErrorReviewComment: 'Kommentar ist erforderlich',
    ErrorOverallRating: 'Bewertung ist erforderlich',
    ErrorSubHeader: 'Ihre Bewertung wurde nicht eingereicht.',
    OverallRating: 'Gesamtbewertung',
    Review5Star: 'Ausgezeichnet',
    Review4Star: 'Gut',
    Review3Star: 'Durchschnittlich',
    Review2Star: 'Unterdurchschnittlich',
    Review1Star: 'Schlecht',
    ReviewAnonymous: 'Bewertung anonym anzeigen, wenn nicht angekreuzt, wird Ihr Name mit Ihrer Bewertung angezeigt',
    ReviewAttachment: 'Foto oder Video hinzufügen',
    ReviewByAnonymous: 'Anonym',
    ReviewComment: 'Schriftliche Bewertung hinzufügen',
    ReviewPending: 'Bewertung wartet auf Genehmigung',
    ReviewHeader: 'Bewertungen',
    ReviewSubmit: 'Bewertung absenden',
    ReviewTotalPart1: 'von',
    ReviewTotalPart2: 'Bewertungen',
    CommentPlaceholder: 'Was hat Ihnen gefallen oder nicht gefallen? Wofür haben Sie dieses Produkt verwendet?',
    ReviewImageAlt: 'Produktbewertungsbild',
    ClickToUpload: 'Klicken Sie zum Auswählen von Dateien oder ziehen Sie sie hierher',
    SupportedFormats: 'JPEG, PNG, JPG, GIF, MP4',
    RemoveFileTitle: 'Datei entfernen',
    Uploaded: 'Hochgeladen',
    Failed: 'Fehlgeschlagen',
    ExistingAttachments: 'Aktuelle Fotos & Videos',
    DeleteAttachment: 'Diesen Anhang löschen',
    Delete: 'Löschen',
    DeleteAttachmentConfirm: 'Möchten Sie diesen Anhang wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    ErrorDeletingAttachment: 'Fehler beim Löschen des Anhangs. Bitte versuchen Sie es erneut.',
  },
  wishList: {
    CreateList: 'Liste erstellen',
    CreateListButton: 'Liste erstellen',
    PageHeader: 'Meine Liste',
    PlaceHolderWishListName: 'Geben Sie einen Namen für Ihre Liste ein',
    WishListButton: 'Meine Wunschliste',
    WishListDetailHeader: 'Meine Wunschlisten',
    WishListHeader: 'Meine Wunschliste',
    WishListItems: 'Artikel',
    WishListSaveTo: 'Speichern unter',
    RemoveFromWishlist: 'Von Wunschliste entfernen',
  },
  languages:{
    de: 'Deutsch',
    en: 'Englisch',
    es: 'Spanisch',
    fr: 'Französisch',
    it: 'Italienisch',
    pt: 'Portugiesisch',
  },
  alerts: {
    Success: 'Erfolg',
    InvoiceChange: 'Rechnungsaktion',
    CancelInvoiceConfirm: 'Möchten Sie diese Rechnung wirklich stornieren?',
    ResendInvoiceConfirm: 'Möchten Sie diese Rechnung wirklich erneut senden?',
    InvoiceCancelled: 'Die Rechnung wurde erfolgreich storniert.',
    InvoiceResent: 'Die Rechnung wurde erfolgreich erneut gesendet.',
    FailedToCancelInvoice: 'Die Rechnung konnte nicht storniert werden. Bitte versuchen Sie es erneut.',
    FailedToResendInvoice: 'Die Rechnung konnte nicht erneut gesendet werden. Bitte versuchen Sie es erneut.',
    CannotCancelInvoice: 'Diese Rechnung kann nicht storniert werden, da sie bereits storniert oder bezahlt ist.',
    CannotResendInvoice: 'Diese Rechnung kann nicht erneut gesendet werden, da sie bereits storniert oder bezahlt ist.',
    AddedToCart: 'In den Warenkorb gelegt!',
    AddToCartError: 'Fehler beim Hinzufügen zum Warenkorb',
    NoQuantityAvailable: 'Im Lager ist nicht genug vorhanden, um mehr zum Warenkorb hinzuzufügen',
    HostOnlyItemTitle: 'Nur für Gastgeber',
    HostOnlyItemMessage: 'Dieser Artikel ist nur für Gastgeber-Warenkörbe verfügbar und kann nicht in einen Gäste-Warenkorb hinzugefügt werden.',
    HostOnlyItemButton: 'Nur Gastgeber',
    DiscountOnlyItemTitle: 'Nur als Rabatt verfügbar',
    DiscountOnlyItemMessage: 'Dieser Artikel kann nur als Teil einer Rabattprämie hinzugefügt werden und nicht manuell.',
    DiscountOnlyItemButton: 'Nur Rabatt',
    DeleteConfirmTitle: 'Löschen',
    DeleteConfirm: 'Sind Sie sicher, dass Sie löschen möchten: {0}',

    CannotBeUndone: 'Dies kann nicht rückgängig gemacht werden.',

    AOEEventNotCancellableException: {
      CartSubmitted: 'Diese Veranstaltung kann nicht storniert werden, da ein Warenkorb bereits übermittelt wurde.',
      CartHasPayments: 'Diese Veranstaltung kann nicht storniert werden, da ein Warenkorb Zahlungen enthält.',
    },

    AOEEventNotEmptyException: {
      OrdersExist: 'Diese Veranstaltung kann nicht gelöscht werden, da Bestellungen dafür vorhanden sind.',
      CartSubmitted: 'Diese Veranstaltung kann nicht gelöscht werden, da ein Warenkorb bereits übermittelt wurde.',
      CartHasPayments: 'Diese Veranstaltung kann nicht gelöscht werden, da ein Warenkorb Zahlungen enthält.',
      CartHasItems: 'Diese Veranstaltung kann nicht gelöscht werden, da ein Warenkorb noch Artikel enthält.',
    },

    AOEEventNotClosableException: {
      CartHasItems: 'Diese Veranstaltung kann nicht abgeschlossen werden, da ein Warenkorb noch nicht übermittelte Artikel enthält.',
    },

    SfaEventNotCancellableException: {
      C: 'Diese Veranstaltung ist bereits abgeschlossen und kann nicht storniert werden.',
      X: 'Diese Veranstaltung wurde bereits storniert.',
      I: 'Diese Veranstaltung kann nicht storniert werden, während eine Bestellübermittlung läuft.',
    },

    SfaEventNotDeletableException: {
      O: 'Diese Veranstaltung muss vor dem Löschen storniert oder abgeschlossen werden.',
      C: 'Diese Veranstaltung kann nicht gelöscht werden.',
      I: 'Diese Veranstaltung kann nicht gelöscht werden, während eine Bestellübermittlung läuft.',
    },

    SfaEventReadOnlyException: {
      C: 'Diese Veranstaltung ist abgeschlossen und kann nicht bearbeitet werden.',
      X: 'Diese Veranstaltung wurde storniert und kann nicht bearbeitet werden.',
    },
    NoPermissions: 'Sie haben keine Berechtigung, diese Aktion durchzuführen. ({0})',
    UnsavedChanges: 'Sie haben ungespeicherte Änderungen. Möchten Sie diese speichern?',
    ProductEligibilityQuantityGatewayException: 'Die maximal zulässige Menge für dieses Produkt beträgt {ruleQuantity}.',
    ProductEligibilityOrderTotalGatewayException: 'Der Bestellwert von {orderTotal} überschreitet die Bestellwertgrenze von {orderTotalCap}.',
    PoeDiscCouponNotFoundException: 'Der Gutschein, den Sie verwenden möchten, ist ungültig.',
    PoeDiscCouponDiscountPlanNotFoundException: 'Der Gutschein, den Sie verwenden möchten, ist für diese Bestellung nicht gültig.',
    SingleUseOrderLimitTitle: 'Bestelllimit erreicht',
    SingleUseOrderLimitMessage: 'Sie haben bereits eine Bestellung aufgegeben. Nur eine Kit Enhancement-Bestellung ist zulässig.',
    AOEPaymentMappingException: {
      CREDIT_CARD_NUMBER_MUST_BE_TEST_NUMBER:
        'Kreditkartennummer ist keine akzeptierte Testnummer',
      DO_NOT_HONOR: 'Zahlung vom Kartenaussteller abgelehnt',
      INSUFFICIENT_FUNDS: 'Unzureichende Deckung',
      INVALID_NUMBER: 'Ungültige Kartennummer',
    },
    CartSubmit : {
      UnknownError: 'Der Warenkorb konnte aufgrund eines unbekannten Fehlers nicht übermittelt werden',
      NotBalanced: 'Der Warenkorb konnte nicht übermittelt werden, da der Warenkorb unausgeglichen ist',
      SkuWarehouseNotFound: 'Der Warenkorb konnte nicht übermittelt werden, da das Lager für {SkuCode} nicht gefunden wurde',
      SkuWarehouseNotAvailable : 'Der Warenkorb konnte nicht übermittelt werden, da {SkuCode} im Lager nicht verfügbar ist',
      SkuWarehouseStopSell  : 'Der Warenkorb konnte nicht übermittelt werden, da {SkuCode} im Lager ausverkauft ist',
      CouponAlreadyUsed: 'Dieser Gutschein wurde bereits verwendet und kann nicht erneut angewendet werden',
      ShippingAddressMissing: 'Der Warenkorb konnte nicht übermittelt werden, da die Lieferadresse fehlt',
      ShippingMethodMissing: 'Der Warenkorb konnte nicht übermittelt werden, da die Versandmethode fehlt',
      CustomerInformationMissing: 'Der Warenkorb konnte nicht übermittelt werden, da Name und E-Mail-Adresse des Kunden fehlen',
      SkuNotAvailableForShippingCountry: 'Der Warenkorb konnte nicht übermittelt werden, da {SkuCode} im Lieferland nicht verfügbar ist',
    },
    AOESkuWarehouseReservationCreateException: "Der Warenkorb konnte nicht übermittelt werden, da ein oder mehrere Artikel nicht mehr verfügbar sind",
    AOEInvoiceCartNotFoundException: 'Rechnung nicht gefunden',
    AOECartInvoiceStatusInvalidException: 'Die Rechnung kann nicht mehr bezahlt werden',
    PoeDiscCouponAlreadyUsedException: 'Dieser Gutschein wurde bereits verwendet und kann nicht erneut angewendet werden',
    AOESkuExpiredException: "SKU '{skuCode}' ist nicht mehr verfügbar. Bitte entfernen Sie sie aus Ihrem Warenkorb, um zur Kasse zu gehen.",
    AOESkuShippingRestrictionException: "SKU '{skuCode}' ist für die ausgewählte Versandmethode nicht verfügbar",
    AOESkuNotAvailableForShippingCountryException: "SKU '{skuCode}' ist im Lieferland nicht verfügbar",
    AOECountryShippingRestrictionException: "Die ausgewählte Versandmethode ist für das Land '{countryCode}' nicht verfügbar",
    GeneralError: 'Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten ({messageKey})',
    AxiosError: 'Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten: {message} ({name} {code})',
    FailedToGetCurrentBatchNumber: 'Aktuelle Batch-Nummer konnte nicht abgerufen werden.',
    BeeAddressBookReferencedByEventException: 'Dieser Kontakt kann nicht gelöscht werden, da er mit einer oder mehreren Veranstaltungen verknüpft ist. Bitte entfernen Sie den Kontakt aus allen Veranstaltungen, bevor Sie ihn löschen.',
    CartSubmitSuccessTitle: 'Erfolg!',
    CartSubmitSuccess: 'Ihr Warenkorb wurde übermittelt'
  },
  accountInfo: {
    title: 'Kontoverwaltung',
    personalData: {
      title: 'Personenbezogene Daten anfordern',
      description: 'Fordern Sie eine Kopie Ihrer personenbezogenen Daten an oder beantragen Sie die Löschung',
      updateTitle: 'Anfrage zu personenbezogenen Daten',
      updateDescription: 'Fordern Sie Ihre personenbezogenen Daten oder die Löschung Ihres Kontos an. Wir bearbeiten Ihre Anfrage gemäß den geltenden Datenschutzgesetzen.',
      selectRequest: 'Wählen Sie Ihre Anfrage:',
      exportData: 'Personenbezogene Daten exportieren',
      deleteData: 'Personenbezogene Daten löschen',
      emailAddress: 'Ihre E-Mail-Adresse (erforderlich):',
      emailPlaceholder: 'E-Mail-Adresse eingeben',
      sendRequest: 'Anfrage senden',
      emailRequired: 'E-Mail-Adresse ist erforderlich',
      emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      emailMismatch: 'Die eingegebene E-Mail-Adresse ist ungültig.',
      optionRequired: 'Bitte wählen Sie eine Anfrageoption aus',
      exportSuccess: 'Ihre Datenexport-Anfrage wurde erfolgreich übermittelt. Sie können Ihren Bericht jetzt als PDF herunterladen.',
      deleteSuccess: 'Ihre Anfrage zur Datenlöschung wurde erfolgreich übermittelt.',
      submitError: 'Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
      exportOptionsTitle: 'Ihr Export personenbezogener Daten',
      exportOptionsDescription: 'Ihre Datenexport-Anfrage wurde verarbeitet. Sie können den Bericht als PDF herunterladen.',
      downloadPDF: 'PDF-Bericht herunterladen',
      viewReport: 'Bericht anzeigen',
      reportTitle: 'Bericht zum Export personenbezogener Daten',
      newRequest: 'Neue Anfrage erstellen',
      pdfNoProfileDataError: 'Keine Profildaten verfügbar. Bitte senden Sie die Anfrage erneut.',
      pdfNoAddressDataError: 'Adressdaten wurden nicht geladen. Bitte senden Sie die Anfrage erneut.',
      pdfComponentNotReadyError: 'Die PDF-Export-Komponente ist noch nicht bereit. Bitte versuchen Sie es erneut.',
      pdfDownloadFailedError: 'PDF-Download fehlgeschlagen. Bitte versuchen Sie es erneut oder verwenden Sie die Druckfunktion Ihres Browsers.',
      reportHeader: 'Export personenbezogener Daten',
      businessInformation: 'Geschäftsinformationen:',
      personalInformation: 'Persönliche Informationen:',
      contactInformation: 'Kontaktinformationen:',
      phoneNumbers: 'Telefonnummern:',
      addresses: 'Adressen:',
      governmentIds: 'Ausweisdokumente:',
      governmentIdType: 'Ausweis-Typ:',
      taxPayerIdLastFour: 'Letzte vier Ziffern:',
      noGovernmentIdsOnFile: 'Keine Ausweisdokumente hinterlegt.',
      customerNumber: 'Kundennummer:',
      dateOfBirth: 'Geburtsdatum:',
      username: 'Benutzername:',
      anniversary: 'Jahrestag:',
      name: 'Name:',
      social: 'Social Media:',
      firstName: 'Vorname:',
      lastName: 'Nachname:',
      preferredName: 'Bevorzugter Name:',
      alternativeFirstName: 'Alternativer Vorname:',
      alternativeLastName: 'Alternativer Nachname:',
      webUrl: 'Web-URL:',
      imHandle: 'IM-Handle:',
      facebook: 'Facebook:',
      twitter: 'Twitter:',
      linkedIn: 'LinkedIn:',
      pinterest: 'Pinterest:',
      reportEmailAddress: 'E-Mail-Adresse:',
      home: 'Privat',
      mobile: 'Mobil',
      fax: 'Fax',
      work: 'Arbeit',
      shippingAddress: 'Lieferadresse',
      billingAddress: 'Rechnungsadresse',
      mailingAddress: 'Postadresse',
      addressName: 'Name:',
      company: 'Firma:',
      addressLine1: 'Adresszeile 1:',
      addressLine2: 'Adresszeile 2:',
      city: 'Stadt:',
      stateProvince: 'Bundesland/Provinz:',
      postalCode: 'Postleitzahl:',
      country: 'Land:',
      noAddressesOnFile: 'Keine Adressen hinterlegt.',
      reportFooterText: 'Bericht zum Export personenbezogener Daten - erstellt am',
      requestType: 'Anfragetyp: Datenexport',
      notAvailable: 'N/V'
    },
    orderHistory: {
      title: 'Bestellverlauf',
      description: 'Sehen Sie sich Ihre bisherigen Bestellungen an und verfolgen Sie Sendungen',
      updateTitle: 'Bestellverlauf',
      updateDescription: 'Sehen und verwalten Sie hier Ihren Bestellverlauf.',
      loadError: 'Bestellverlauf konnte nicht geladen werden',
      errorLoading: 'Fehler beim Laden des Bestellverlaufs. Bitte versuchen Sie es erneut.',
      ordersFound: '{count} Bestellungen gefunden',
      orderNumber: 'Bestellnummer',
      orderDate: 'Bestelldatum',
      viewReceipt: 'Beleg anzeigen',
      orderType: 'Bestelltyp',
      customer: 'Kunde',
      tracking: 'Sendungsverfolgung',
      commissionValue: 'Provisionswert',
      noOrders: 'Keine Bestellungen gefunden',
      noOrdersDescription: 'Sie haben noch keine Bestellungen in Ihrem Verlauf.',
      showingResults: 'Anzeige von {start}-{end} von {total} Ergebnissen',
      itemsPerPage: 'Einträge pro Seite',
      orderDetails: 'Bestelldetails',
      orderInformation: 'Bestellinformationen',
      customerInformation: 'Kundeninformationen',
      shippingInformation: 'Versandinformationen',
      commissionInformation: 'Provisionsinformationen',
      orderTotal: 'Bestellsumme',
      customerName: 'Kundenname',
      customerEmail: 'Kunden-E-Mail',
      additionalDetails: 'Weitere Details',
      detailsLoaded: 'Details geladen',
      noDetailToken: 'Detaillierte Informationen für diese Bestellung nicht verfügbar',
      orderSummary: 'Bestellübersicht',
      shippingCost: 'Versandkosten',
      taxAmount: 'Steuerbetrag',
      orderTypeId: 'Bestelltyp-ID',
      productDetails: 'Produktdetails',
      skuCode: 'SKU-Code',
      productName: 'Produktname',
      productImage: 'Produkt',
      quantity: 'Menge',
      price: 'Preis',
      lineTotal: 'Zeilensumme',
      detailLoadError: 'Bestelldetails konnten nicht geladen werden',
      orderStatus: 'Bestellstatus',
      paymentDetails: 'Zahlungsdetails',
      subtotal: 'Zwischensumme',
      paymentMethod: 'Zahlungsmethode',
      paymentProcessed: 'Verarbeitet',
      paymentAuthorized: 'Autorisiert',
      paymentRefunded: 'Erstattet',
      authCode: 'Autorisierungscode',
      shippingTo: 'Versand an',
      shippingMethod: 'Versandmethode',
      discount: 'Rabatt',
      shippingAndHandling: 'Versand und Handling',
      inTotal: 'GESAMT',
      billingAddress: 'Rechnungsadresse'
    },
    billingAddress: {
      title: 'Rechnungs- und Lieferadresse',
      description: 'Aktualisieren Sie Ihre Rechnungs- und Lieferadresse',
      updateTitle: 'Rechnungs- und Lieferadresse aktualisieren',
      updateDescription: 'Diese Funktion wird bald verfügbar sein. Sie können hier Ihre Rechnungs- und Lieferadresse aktualisieren.',
      noAddressSet: 'Keine Rechnungsadresse festgelegt',
      change: 'Ändern',
      addNew: 'Neu hinzufügen',
      editAddress: 'Adresse bearbeiten',
      addNewAddress: 'Neue Adresse hinzufügen',
      saveSuccess: 'Adresse erfolgreich gespeichert',
      saveError: 'Fehler beim Speichern der Adresse',
      selectAddress: 'Auswählen',
      currentBilling: 'Rechnungsadresse',
      currentShipping: 'Lieferadresse',
      createNew: 'Neue Adresse erstellen',
      addressUpdated: 'Adresse erfolgreich aktualisiert',
      updateError: 'Fehler beim Aktualisieren der Adresse',
      requiredFields: 'Bitte füllen Sie die folgenden Pflichtfelder aus',
      billing: 'Rechnung',
      shipping: 'Versand',
      noBillingAddress: 'Keine Rechnungsadresse',
      noShippingAddress: 'Keine Lieferadresse',
      addBillingAddress: 'Rechnungsadresse hinzufügen',
      addShippingAddress: 'Lieferadresse hinzufügen',
      deleteAddress: 'Adresse löschen',
      deleteConfirmTitle: 'Adresse löschen?',
      deleteConfirmMessage: 'Sind Sie sicher, dass Sie diese Adresse löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      deleteSuccess: 'Adresse erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen der Adresse',
      cannotDeleteTitle: 'Adresse kann nicht gelöscht werden',
      cannotDeleteMessage: 'Diese Adresse kann nicht gelöscht werden, da sie derzeit als Ihre {type}adresse festgelegt ist. Bitte wählen Sie zuerst eine andere Adresse aus.',
      defaultBadge: 'Standard'
    },
    contactDetails: {
      title: 'E-Mail, Passwort und Kontaktdaten ändern',
      description: 'Aktualisieren Sie E-Mail-Adresse, Passwort und Kontaktdaten',
      updateTitle: 'Kontaktinformationen',
      updateDescription: 'Verwalten Sie Ihre E-Mail-Adresse, Ihr Passwort und weitere Kontaktinformationen.',
      changeEmailPassword: 'E-Mail und Passwort ändern',
      currentPassword: 'Aktuelles Passwort *',
      currentPasswordPlaceholder: 'Geben Sie Ihr aktuelles Passwort ein',
      currentPasswordRequired: 'Aktuelles Passwort ist erforderlich',
      currentPasswordTooShort: 'Das aktuelle Passwort muss mindestens 8 Zeichen lang sein',
      newPassword: 'Neues Passwort',
      newPasswordPlaceholder: 'Neues Passwort eingeben',
      newPasswordRequired: 'Neues Passwort ist erforderlich',
      newPasswordTooShort: 'Das neue Passwort muss mindestens 8 Zeichen lang sein',
      newPasswordWeak: 'Das Passwort muss Großbuchstaben, Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten',
      newPasswordSameAsCurrent: 'Das neue Passwort muss sich vom aktuellen Passwort unterscheiden',
      confirmPassword: 'Neues Passwort bestätigen',
      confirmPasswordPlaceholder: 'Bestätigen Sie Ihr neues Passwort',
      confirmPasswordRequired: 'Bitte bestätigen Sie Ihr neues Passwort',
      passwordsDoNotMatch: 'Die Passwörter stimmen nicht überein',
      passwordChangeSuccess: 'Passwort erfolgreich geändert',
      passwordChangeError: 'Passwort konnte nicht geändert werden. Bitte überprüfen Sie Ihr aktuelles Passwort.',
      accountDetailsSuccess: 'Kontodetails erfolgreich gespeichert',
      accountDetailsError: 'Kontodetails konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.',
      passwordChangeTitle: 'Passwort',
      changePassword: 'Passwort ändern',
      accountDetailsTitle: 'Kontodetails',
      firstName: 'Vorname',
      firstNamePlaceholder: 'Geben Sie Ihren Vornamen ein',
      lastName: 'Nachname',
      lastNamePlaceholder: 'Geben Sie Ihren Nachnamen ein',
      emailAddress: 'Geben Sie Ihre E-Mail-Adresse ein',
      emailAddressPlaceholder: 'Geben Sie Ihre E-Mail-Adresse ein',
      phoneCountry: 'Telefon',
      phoneNumber: 'Telefonnummer',
      phoneNumberPlaceholder: '(123) 456-7890',
      mobileCountry: 'Mobil',
      mobileNumber: 'Mobilnummer',
      mobileNumberPlaceholder: '(123) 456-7890',
      saveAccountDetails: 'Kontodetails speichern',
    },
    termsConditions: {
      title: 'Allgemeine Geschäftsbedingungen',
      description: 'Allgemeine Geschäftsbedingungen anzeigen',
      updateTitle: 'Allgemeine Geschäftsbedingungen',
      updateDescription: 'Überprüfen Sie die aktuellen Allgemeinen Geschäftsbedingungen für Ihr Konto.'
    },
    dataProvisions: {
      title: 'Datenschutzrichtlinie',
      description: 'Datenschutzrichtlinie anzeigen',
      updateTitle: 'Datenschutzeinstellungen',
      updateDescription: 'Ändern Sie Ihre Marketing-Opt-in-Auswahl und verwalten Sie Ihre Datenschutzeinstellungen.',
      termsId: 'Globale ID',
      contractName: 'Vertragsname',
      version: 'Version',
      acknowledgedDate: 'Unterschriftsdatum',
      deliveredOn: 'Zugestellt am',
      signByDate: 'Unterschrift bis',
      status: 'Status',
      statusAccepted: 'Akzeptiert',
      statusDeclined: 'Abgelehnt',
      statusPending: 'Ausstehend',
      noContracts: 'Keine Datenschutzrichtlinie gefunden',
      noContractsDescription: 'Sie haben derzeit keine Datenschutzrichtlinie oder Verträge verfügbar.',
      errorNoUser: 'Kein authentifizierter Benutzer gefunden',
      errorLoading: 'Fehler beim Laden der Datenschutzrichtlinie. Bitte versuchen Sie es erneut.'
    },
    marketingOptIn: {
      title: 'Marketing-Einwilligung',
      description: 'Verwalten Sie Ihre Marketingkommunikationspräferenzen',
      updateTitle: 'Marketingpräferenzen',
      updateDescription: 'Wählen Sie aus, welche Marketingmitteilungen Sie erhalten möchten.',
      errorLoading: 'Marketingpräferenzen konnten nicht geladen werden',
      errorSaving: 'Marketingpräferenzen konnten nicht gespeichert werden',
      errorNoUser: 'Keine Benutzerinformationen verfügbar',
      saveSuccess: 'Marketingpräferenzen erfolgreich gespeichert',
      noChangesToSave: 'Keine Änderungen zum Speichern',
      optedIn: 'Zugestimmt',
      optedOut: 'Abgelehnt',
      lastModified: 'Zuletzt geändert',
      noOptionsTitle: 'Keine Marketingoptionen verfügbar',
      noOptionsDescription: 'Derzeit sind keine Marketingkommunikationsoptionen für Ihr Konto verfügbar.'
    },
  },
  columns: {
    birthDate: 'Geburtsdatum',
    birthDatePlaceholder: 'Tag/Monat/Jahr',
    countryCode: 'Ländercode',
    country: 'Ländername',
    currencyId: 'Währung',
    state: 'Staatenname',
    countryCodeIsoalpha3: 'ISO 3',
    isEnabled: 'Aktiviert',
    templateName: 'Vorlagenname',
    templateDescription: 'Beschreibung',
    schemaName: 'Schema-Name',
    cultureName: 'Kulturname',
    messageBody: 'Nachrichtentext',
    documentName: 'Dokumentenname',
    documentSubject: 'Dokumentbetreff',
    codeIdClassification: 'Klassifikation',
    firstName: 'Vorname',
    lastName: 'Nachname',
    emailAddress: 'E-Mail',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    phone: 'Telefonnummer',
    city: 'Stadt',
    addressLine1: 'Straßenadresse',
    addressLine2: 'Apt, Suite, usw',
    stateCode: 'Bundesland/Provinz',
    postalCode: 'Postleitzahl',
    addressFirstName: 'Vorname',
    addressLastName: 'Nachname',
    title: 'Titel',
    companyName: 'Firma',
    primaryPhone: {
      number: 'Telefonnummer'
    },
    primaryPhoneNumber: 'Telefonnummer',
    alt1PhoneNumber: 'Alternative Telefonnummer',
    alt2PhoneNumber: 'Alternative Telefonnummer 2',
    alt3PhoneNumber: 'Alternative Telefonnummer 3',
    preferredName: 'Bevorzugter Name',
    billingFirstName: 'Vorname',
    billingLastName: 'Nachname',
    facebookId: 'Facebook',
    linkedInId: 'LinkedIn',
    twitterId: 'Twitter',
    pinterestId: 'Pinterest',
  },
  consultantLocator: {
    welcomeHeader: "Schön, dass du dabei bist!",
    teamJoiningHeader: "Für welches Team entscheidest du dich?",
    searchByText: "Finde den passenden Berater für dich",
    nameTab: "Name",
    locationTab: "Standort",
    country: "Land",
    countryDE: "Deutschland",
    countryAT: "Österreich",
    countryFR: "Frankreich",
    directSignupText: "Noch keine Beraterin an deiner Seite? Aktiviere einfach das Kästchen und starte direkt mit uns durch.",
    directSignupError: "Direktanmeldung konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
    whyJoinConsultantQuestion: "Du startest nicht allein",
    whyJoinConsultantPersonal: "Du startest nicht allein",
    consultantTeamInfo: "Bei Pampered Chef legen wir großen Wert auf persönliche Betreuung. Mit einem Berater an deiner Seite hast du jederzeit Unterstützung, Orientierung und einen festen Ansprechpartner.",
    experienceInfo: "So sorgen wir dafür, dass dein Start und dein Weg bei Pampered Chef angenehm, transparent und erfolgreich sind.",
    selectDifferentConsultant: "Anderen Berater auswählen",
    selectAndContinue: "Auswählen & Fortfahren",
    consultantsFound: "Berater gefunden",
    noConsultantsFound: "Keine Berater in diesem Bereich gefunden. Bitte versuchen Sie eine andere Postleitzahl.",
    enterConsultantName: "Vor- oder Nachnamen eingeben",
    enterZipCode: "Postleitzahl eingeben",
    searchRadius: "Suchradius",
    kilometers: "km"
  },

  partyOrderEntry: {
    BreadCrumbPage: 'Kochshow-Bestelleingabe',
    BreadCrumbOrderSummary: 'Bestellübersicht',
    BreadCrumbGuest: 'Gast',
    BreadCrumbHost: 'Gastgeber',
    BreadCrumbOrder: 'Bestellung',
    Actions: 'Löschen',
    ActiveCartHeader: 'Aktiv',
    AddGuestButton: 'Gast hinzufügen',
    AddGuestSectionHeader: 'Gast hinzufügen',
    ProductSubtotalByCategory: 'Produktzwischensumme nach Kategorie',
    PriceCategoryName: 'Kategorie',
    SumTotalPrice: 'Gesamtpreis',
    Discount: 'Rabatt %',
    FinalSum: 'Endsumme',
    BuyingDiscount: 'Kaufrabatt',
    AddNewAddress: 'Neue Adresse',
    AddNewCustomerButton: 'Neuen Kunden hinzufügen',
    AddCustomerEmailButton: 'Bestehenden Kunden hinzufügen',
    Available: 'Erhältlich',
    BalanceHeader: 'Saldo',
    BecomeAConsultant: 'Interesse an einer Beratertätigkeit',
    CancelHostingEvent: 'Abbrechen',
    CatalogEntry: 'Katalog',
    CatalogRetailPrice: 'Einzelhandelspreis',
    CatalogYourPrice: 'Ihr Preis',
    Category: 'Kategorie',
    CategoryEntry: 'Kategorie',
    CategoryEntryBuyingDiscountHeader: 'Kaufrabatt',
    CategoryEntryHeader: 'Kategorie auswählen',
    CategoryEntryItemHeader: 'Artikel #',
    CategoryEntryProductHeader: 'Produkt',
    CategoryEntryRetailHeader: 'Preis',
    CategoryEntryUOMHeader: 'Maßeinheit',
    CategoryEntryYourPriceHeader: 'Ihr Preis',
    ChangeAddressButton: 'Ändern',
    ChangeAddressNewAddress: 'Neue Adresse',
    ChangeAddressError: 'Bitte wählen Sie eine Adresse aus',
    ChangeAddressPopupHeader: 'Konsolidierte Adresse ändern',
    ChangeAddressPopupSubHeader: 'Wählen Sie eine bestehende Adresse aus der Liste oder geben Sie eine neue Adresse für die konsolidierte Adresse ein',
    ConsolidatedAddress: 'Konsolidierte Adresse',
    ConsultantName: 'Berater',
    ConsultantSummary: 'Berater',
    CreditCartSubmit: 'Zahlung hinzufügen',
    CustomerNameHeader: 'Name',
    DetailsHeader: 'Artikel',
    DiscountHeader: 'Rabatt',
    DiscountSectionHeader: 'Rabatte und Sonderangebote',
    EventDate: 'Veranstaltungsdatum',
    EventId: 'Veranstaltung',
    FreeDollarCoupons: 'Sie können einige Ihrer Gastgeber-Dollars für einen Gutschein verwenden',
    FreeDollarCouponsBtn: 'Verfügbare Gutscheine ansehen',
    FreeDollarCouponsPopupHeader: 'Verfügbare Gutscheine',
    FreeDollarCouponsRemoveBtn: 'Gutschein entfernen',
    FreeDollarItemSelect: 'Wählen Sie den Artikel aus, für den Sie einen Free-Dollar-Rabatt erhalten möchten',
    InactivatingCartTitle: 'Warenkorb deaktivieren',
    InactivatingCartMessage: 'Diese Aktion leert den ausgewählten Warenkorb und er wird nicht mit der Bestellung übermittelt.',
    InactivatingCartConfirm: 'Möchten Sie fortfahren?',
    ReactivateCartHeader: 'Reaktivieren',
    ReactivateCart: 'Diesen Warenkorb reaktivieren',
    CartDeactivatedMessage: 'Dieser Warenkorb wurde deaktiviert und wird nicht mit der Bestellung übermittelt. Reaktivieren Sie ihn unten, um ihn wieder hinzuzufügen.',
    ReactivatingCartTitle: 'Warenkorb reaktivieren',
    ReactivatingCartMessage: 'Diese Aktion fügt den ausgewählten Warenkorb der Party wieder hinzu und er wird mit der Bestellung übermittelt.',
    ReactivatingCartConfirm: 'Möchten Sie fortfahren?',
    GridFooterTotal: 'Gesamt',
    GuestListAdd: 'Gäste (+)',
    GuestName: 'Gast',
    GuestOrderHeaderSectionHeader: 'Gästebestellung',
    Host: 'Gastgeber',
    HostAParty: 'Interesse an der Ausrichtung einer Party',
    HostOrderHeaderSectionHeader: 'Gastgeberbestellung',
    HostSummary: 'Gastgeber-Zusammenfassung',
    ItemEntry: 'Artikeleingabe',
    ItemNotAvailable: 'Nicht auf Lager',
    LowStock: 'Geringer Bestand',
    MakePaymentTitle: 'Zahlung vornehmen',
    MissingPricing: 'Preis nicht verfügbar',
    NumberOfGuests: 'Gäste',
    NumberOfGuestOrders: 'Gästebestellungen',
    PartyDate: 'Partydatum',
    PaymentCharge: 'Betrag',
    PaymentName: 'Name',
    PaymentReference: 'Referenz',
    PaymentStatus: 'Status',
    PaymentType: 'Typ',
    ProductImageHeader: 'Bild',
    PSHeader: 'PS',
    Options: 'Optionen',
    OrderNumberHeader: 'Bestellnr.',
    OrderSummary: 'Bestellübersicht',
    OrderSummaryBalanceDue: 'Fälliger Betrag',
    OrderSummaryDiscount: 'Rabatt',
    OrderSummaryDonations: 'Spenden',
    OrderSummaryFees: 'Gebühren',
    OrderSummaryPaymentsMade: 'Geleistete Zahlungen',
    OrderSummaryProductSubtotal: 'Produkt-Zwischensumme',
    OrderSummarySectionHeader: 'Bestellübersicht',
    OrderSummaryShipping: 'Versand',
    OrderSummarySubtotal: 'Zwischensumme',
    OrderSummaryTax: 'Steuer',
    OrderSummaryTotal: 'Gesamtsumme',
    OutOfStock: 'Nicht verfügbar',
    PartyOrderSummaryGuestOrdersSectionHeader: 'Gästebestellungen',
    PartyOrderSummaryHostOrdersSectionHeader: 'Gastgeberbestellung',
    PaymentHeader: 'Zahlungen',
    PaymentSectionHeader: 'Zahlungsinformationen',
    QuantityHeader: 'Menge',
    RetailHeader: 'Einzelhandel',
    SaveAddressButton: 'Adresse speichern',
    SaveHostingEvent: 'Speichern',
    SelectDate: 'Datum für die Veranstaltung wählen',
    ShipNowButton: 'Jetzt versenden',
    ShipNowHoverTitleBalance: 'Offener Betrag im Warenkorb',
    ShipNowHoverTitleNoItems: 'Keine Artikel im Warenkorb',
    ShipNowHoverTitleNoPayment: 'Keine Zahlungen im Warenkorb',
    ShippingAddressTitle: 'Lieferadresse',
    ShippingCostHeader: 'Versandkosten',
    ShippingSectionHeader: 'Versandinformationen',
    ShippingMethodsSectionHeader: 'Versandmethode',
    ShipMethodTypesTitle: 'Versenden mit',
    ShipToTypesTitle: 'Versenden an',
    SingleLineEntry: 'Einzelzeile',
    Step1AddGuestLabel: 'Schritt 1: Option wählen',
    Step2AddExistingGuestLabel: 'Schritt 2: Gast im Adressbuch finden',
    Step2AddNewGuestLabel: 'Schritt 2: Gast-Informationen eingeben',
    StopSell: 'Ausverkauft',
    SubmitButton: 'Party einreichen',
    SubTotalHeader: 'Zwischensumme',
    TotalHeader: 'Gesamt',
    UpdateCartButton: 'Warenkorb aktualisieren',
    ViewOrderReceipt: 'Bestellbeleg anzeigen',
    YourShoppingCart: 'Ihr Warenkorb',
    NoResultsFound: 'Keine Ergebnisse gefunden.',
    BackToEventManagement: 'Zurück zur Veranstaltungsverwaltung'
  },
  consultantOrderEntry: {
    CartSummaryHeader: 'Warenkorb Zusammenfassung',
    ProceedToCheckout: 'Zur Kasse gehen',
    SubmitButton: 'Einreichen',
    ContinueShoppingButton: 'Weiter einkaufen'
  },
  consultantCorner: {
    myAccountRenewalReminder: {
      message: 'Ihr aktueller Plan endet in {days} Tagen. Überprüfen Sie jetzt Ihre Verlängerungseinstellungen.',
      messageToday: 'Ihr aktueller Plan läuft heute ab. Überprüfen Sie jetzt Ihre Verlängerungseinstellungen.',
      messageExpired: 'Ihr aktueller Plan ist abgelaufen. Überprüfen Sie jetzt Ihre Verlängerungseinstellungen.',
      trialMessage: 'Ihr Testzeitraum endet in {days} Tagen. Überprüfen Sie jetzt Ihre Verlängerungseinstellungen.',
      trialMessageToday: 'Ihr Testzeitraum läuft heute ab. Überprüfen Sie jetzt Ihre Verlängerungseinstellungen.',
      trialMessageExpired: 'Ihr Testzeitraum ist abgelaufen. Überprüfen Sie jetzt Ihre Verlängerungseinstellungen.',
      action: 'Zu den Webshop-Einstellungen',
      dismiss: 'Schließen'
    },
    security: {
      passwordHeader: 'Passwort Ändern',
      passwordSubHeader: 'Aktualisieren Sie Ihr Kontopasswort für erhöhte Sicherheit',
      oldPasswordLabel: 'Aktuelles Passwort',
      oldPasswordPlaceholder: 'Geben Sie Ihr aktuelles Passwort ein',
      newPasswordLabel: 'Neues Passwort',
      newPasswordPlaceholder: 'Geben Sie Ihr neues Passwort ein',
      confirmPasswordLabel: 'Neues Passwort Bestätigen',
      confirmPasswordPlaceholder: 'Bestätigen Sie Ihr neues Passwort',
      passwordRequirements: 'Passwort-Anforderungen:',
      requirement1: 'Mindestens 8 Zeichen lang',
      requirement2: 'Mindestens ein Kleinbuchstabe',
      requirement3: 'Mindestens ein Großbuchstabe',
      requirement4: 'Mindestens eine Zahl',
      requirement5: 'Mindestens ein Sonderzeichen',
      savePassword: 'Passwort Speichern',
      saving: 'Speichern...',
      oldPasswordRequired: 'Aktuelles Passwort ist erforderlich',
      newPasswordRequired: 'Neues Passwort ist erforderlich',
      newPasswordTooShort: 'Passwort muss mindestens 8 Zeichen lang sein',
      newPasswordWeak: 'Passwort erfüllt nicht die Anforderungen',
      newPasswordSameAsCurrent: 'Das neue Passwort muss sich vom aktuellen Passwort unterscheiden',
      confirmPasswordRequired: 'Bitte bestätigen Sie Ihr neues Passwort',
      passwordsDoNotMatch: 'Passwörter stimmen nicht überein',
      passwordSaveSuccess: 'Passwort erfolgreich aktualisiert',
      passwordSaveError: 'Fehler beim Aktualisieren des Passworts. Bitte versuchen Sie es erneut.'
    },
    contactDetails: {
      ContactDetails: 'Kontaktdaten',
      UpdateContactInfo: 'Aktualisieren Sie Ihre Kontaktinformationen',
      PageLoadError: 'Fehler beim Laden der Kontaktdaten',
      SaveError: 'Fehler beim Speichern der Kontaktinformationen',
      SaveErrorGeneric: 'Ein unerwarteter Fehler ist beim Speichern Ihrer Kontaktinformationen aufgetreten. Bitte versuchen Sie es erneut.',
      SaveSuccess: 'Kontaktinformationen erfolgreich gespeichert',
      NetworkError: 'Netzwerkfehler aufgetreten. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
      ValidationError: 'Bitte korrigieren Sie die Validierungsfehler und versuchen Sie es erneut.',
      TryAgain: 'Erneut Versuchen',
      LoadingContactDetails: 'Kontaktdaten werden geladen...',
      CancelButton: 'Abbrechen',
      SaveContactInfo: 'Kontaktinformationen speichern',
      Saving: 'Speichern...',
      AccountInfo: 'Kontoinformationen',
      Username: 'Benutzername',
      NameSection: 'Namensinformationen',
      FirstName: 'Vorname',
      LastName: 'Nachname',
      ContactInfo: 'Kontaktinformationen',
      EmailAddress: 'E-Mail-Adresse',
      PrimaryPhone: 'Festnetz',
      MobilePhone: 'Mobiltelefon',
      PhonePlaceholder: 'Telefonnummer eingeben',
      FirstNameRequired: 'Vorname ist erforderlich',
      LastNameRequired: 'Nachname ist erforderlich',
      EmailRequired: 'E-Mail-Adresse ist erforderlich',
      EmailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      PhoneInvalid: 'Bitte geben Sie eine gültige Telefonnummer ein'
    },
    banking: {
      // Page headers
      BankingDetails: 'Bankdaten',
      ManagePaymentAccounts: 'Verwalten Sie Ihre Zahlungskonten für Bestellungen und Provisionen',
      LoadingBankingDetails: 'Bankdaten werden geladen...',
      PageLoadError: 'Bankdaten konnten nicht geladen werden. Bitte versuchen Sie es erneut.',

      // Current account section
      CurrentPaymentAccount: 'Aktuelles Zahlungskonto',
      UpdatePaymentAccount: 'Zahlungskonto aktualisieren',
      AddPaymentAccount: 'Zahlungskonto hinzufügen',

      // Form fields
      BICCode: 'BIC (Bank Identifier Code)',
      BankName: 'Bankname',
      CurrentIBAN: 'Aktuelle IBAN',
      NewIBAN: 'Neue IBAN',
      DirectDebitAuthorization: 'Ich autorisiere Lastschriftzahlungen für Bestellungen und Provisionen',
      MandateReference: 'Mandatsreferenz',

      // Placeholders
      BICPlaceholder: 'z.B., DEUTDEFF',
      AccountHolder: 'Kontoinhaber',
      AccountHolderPlaceholder: 'z.B., Max Mustermann',
      BankNamePlaceholder: 'z.B., Deutsche Bank',
      BankNamePlaceholder2: 'Wird automatisch ausgefüllt',
      IBANPlaceholder: 'z.B., DE89370400440532013000',

      // Validation messages
      BICRequired: 'BIC ist erforderlich',
      BICInvalidLength: 'BIC muss 8-11 Zeichen lang sein',
      BICInvalidFormat: 'Ungültiges BIC-Format',
      InvalidBICCode: 'Ungültiger BIC-Code',
      BankNameRequired: 'Bankname ist erforderlich',
      AccountHolderRequired: 'Kontoinhaber ist erforderlich',
      IBANRequired: 'IBAN ist erforderlich',
      IBANInvalidLength: 'IBAN muss 15-34 Zeichen lang sein',
      IBANInvalidFormat: 'Ungültiges IBAN-Format',
      AuthorizationRequired: 'Lastschriftautorisierung ist erforderlich',

      // Section titles
      ManagePayouts: 'Verwalten Sie Ihre Auszahlungen',
      ConsultantPaymentAccount: 'Ihr Berater-Zahlungskonto (OPA)',

      // Payout grid
      PayoutAccounts: 'Auszahlungskonten',
      PayoutType: 'Auszahlungstyp',
      Country: 'Land',
      AccountNumber: 'Kontonummer',
      Deposit: 'Einzahlung',
      NoPayoutAccounts: 'Keine Auszahlungskonten konfiguriert',

      payoutType: {
        sepa: 'SEPA',
        bankTransfer: 'Banküberweisung',
      },

      // Modal
      AddAccount: 'Konto hinzufügen',
      AddNewAccount: 'Neues Konto hinzufügen',
      AccountType: 'Kontotyp',
      DirectDeposit: 'Direktüberweisung (Sparkonto)',
      Check: 'Scheck',
      DepositPercentage: 'Einzahlungsprozentsatz',
      DepositPercentagePlaceholder: 'z.B., 50',
      DepositPercentageInvalid: 'Einzahlungsprozentsatz muss zwischen 1 und 100 liegen',
      IBAN: 'IBAN',
      Save: 'Speichern',
      Cancel: 'Abbrechen',

      // Actions
      SaveNewAccount: 'Neues Konto speichern',
      RemoveAccount: 'Zahlungskonto entfernen',
      UpdatePayoutDistribution: 'Auszahlungsverteilung aktualisieren',
      Saving: 'Speichern',
      Removing: 'Entfernen',
      TryAgain: 'Erneut versuchen',

      // Validation
      PercentageTotalMustBe100: 'Gesamtprozentsatz muss 100% betragen. Aktueller Gesamtbetrag: {total}%',
      InvalidPayoutPercentage: 'Bitte passen Sie den Auszahlungsprozentsatz an. Der Gesamtprozentsatz zwischen allen derzeit aktiven und zukünftigen Auszahlungen muss 100% pro Periode betragen.',

      // Success/Error messages
      SaveSuccess: 'Bankdaten erfolgreich gespeichert',
      SaveError: 'Fehler beim Speichern der Bankdaten',
      UnknownError: 'Ein unbekannter Fehler ist aufgetreten',
      RemoveNotImplemented: 'Die Entfernen-Funktion ist noch nicht implementiert',
      UpdateDistributionNotImplemented: 'Die Funktion zur Aktualisierung der Verteilung ist noch nicht implementiert',

      // Delete confirmation
      DeleteAccount: 'Konto löschen',
      DeleteAccountConfirmation: 'Sind Sie sicher, dass Sie dieses Auszahlungskonto löschen möchten?',
      DeleteAccountWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      Delete: 'Löschen',
      DeleteSuccess: 'Auszahlungskonto erfolgreich gelöscht',
      DeleteError: 'Fehler beim Löschen des Auszahlungskontos'
    },
    reportDashboard: {
      defaultConsultantTitle: 'Executive Director',
      errors: {
        noPeriodDatesAvailable: 'Keine Periodendaten verfügbar',
        currentPeriodNotFound: 'Aktuelle Periode nicht gefunden',
      },
    },
    CongratulationsMessageStart: 'Glückwunsch! Sie werden bezahlt als ',
    CongratulationsMessageEnd: ' diesen Monat.',
    ClassId: 'Klasse',
    leads: {
      MyLeads: 'Meine Leads',
      AllLeads: 'Alle Leads',
      leadCount: '{count} Leads',
      LeadSubHeader: 'Überprüfen und verwalten Sie Ihre Leads',
      FirstName: 'Vorname',
      LastName: 'Nachname',
      Email: 'E-Mail',
      Phone: 'Telefon',
      CreateDate: 'Erstellungsdatum',
      Status: 'Status',
      Source: 'Quelle',
      searchPlaceholder: 'Leads durchsuchen...',
      Loading: 'Wird geladen...',
      Actions: 'Aktionen',
      Accept: 'Akzeptieren',
      Reject: 'Ablehnen',
      Refer: 'Weiterleiten',
      ReferTo: 'Weiterleiten an',
      SelectConsultant: 'Berater auswählen',
      NoConsultantsFound: 'Keine Berater gefunden',
      ConfirmAccept: 'Sind Sie sicher, dass Sie diesen Lead akzeptieren möchten?',
      ConfirmReject: 'Sind Sie sicher, dass Sie diesen Lead ablehnen möchten?',
      ConfirmRefer: 'Sind Sie sicher, dass Sie diesen Lead an den ausgewählten Berater weiterleiten möchten?',
      LeadAccepted: 'Lead erfolgreich akzeptiert',
      LeadRejected: 'Lead erfolgreich abgelehnt',
      LeadReferred: 'Lead erfolgreich weitergeleitet',
      Cancel: 'Abbrechen',
      Confirm: 'Bestätigen',
      NoLeads: 'Keine Leads für diesen Kontakt gefunden.',
      LeadType: 'Lead-Typ',
      DistSource: 'Verteilungsquelle',
      AssignedDate: 'Zuweisungsdatum',
      Accepted: 'Akzeptiert',
      Closed: 'Geschlossen',
      Open: 'Offen'
    },
    editContact: {
      PageLoadError: 'Beim Laden der Kontaktdaten ist ein Fehler aufgetreten.',
      EditContact: 'Kontakt bearbeiten',
      EditContactDetails: 'Kontaktdaten hier bearbeiten',
      SaveButton: 'Speichern',
      CancelButton: 'Abbrechen',
      SelectTab: 'Tab auswählen',
      SameAsBilling: 'Wie Rechnungsadresse',
      Name: "Name",
      Email:'E-Mail',
      PrimaryPhone: 'Primäre Telefonnummer',
      AltPhone: 'Alternative Telefonnummer',
      ShippingAddress: 'Lieferadresse',
      BillingAddress: 'Rechnungsadresse',
      SameAsShipping: 'Wie Lieferadresse',
      Communication: 'Kommunikation',
      PhoneCountry: 'Land',
      PhoneType: 'Telefonart',
      NoEmail: 'Keine E-Mail-Adresse verfügbar',
      OrderId: 'Bestellnummer',
      OrderTime: 'Datum',
      OrderStatus: 'Status',
      OrderTotal: 'Gesamt',
      HostName: 'Gastgebername',
      EventDate: 'Veranstaltungsdatum',
      ViewOrders: 'Bestellungen anzeigen',
      Order: 'Bestellung erstellen',
      ClickViewOrders: 'Klicken Sie auf "Bestellungen anzeigen", um das Raster zu laden',
      OrderSummary: 'Bestellübersicht',
      PersonalInformation: 'Persönliche Informationen',
      Language: 'Sprache',
      BirthDate: 'Geburtsdatum',
      Misc: 'Sonstiges',
      Group: 'Gruppe',
      HowDidYouHear: 'Wie haben Sie von uns erfahren',
      AddNotes: 'Notiz hinzufügen',
      SaveSuccess: 'Erfolg!',
      SaveError: 'Fehler',
      ContactUpdatedSuccessfully: 'Kontakt wurde erfolgreich aktualisiert.',
      ContactUpdateFailed: 'Kontakt konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
      AdditionalInfoUpdatedSuccessfully: 'Zusätzliche Informationen wurden erfolgreich aktualisiert.',
      AdditionalInfoUpdateFailed: 'Zusätzliche Informationen konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
      SocialMediaUpdatedSuccessfully: 'Social-Media-Informationen wurden erfolgreich aktualisiert.',
      SocialMediaUpdateFailed: 'Social-Media-Informationen konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
      RequiredFieldsMissing: 'Bitte füllen Sie alle Pflichtfelder aus, bevor Sie speichern.',
      ShippingAddressFieldsRequired: 'Bitte füllen Sie alle erforderlichen Felder der Lieferadresse aus.',
      BillingAddressFieldsRequired: 'Bitte füllen Sie alle erforderlichen Felder der Rechnungsadresse aus.',
      PhoneRequired: 'Bitte geben Sie eine primäre Telefonnummer ein.',
      General: 'Allgemein',
      Lead: 'Lead',
      Tasks: 'Aufgaben',
      Notes: 'Notizen',
      Orders: 'Bestellungen',
      Activity: 'Aktivität',
      AdditionalInformation: 'Zusätzliche Informationen',
      SocialMedia: 'Social Media',
    },
    contacts: {
      title: 'Meine Kontakte',
      allContacts: 'Alle Kontakte',
      contactCount: '{count} Kontakte',
      filters: 'Filter',
      filterTitle: 'Kontakte filtern',
      search: 'Suchen',
      searchPanelTitle: 'Suche',
      clearSearch: 'Zurücksetzen',
      searchOps: {
        all: 'Alle',
        startsWith: 'Beginnt mit',
        endsWith: 'Endet mit',
        contains: 'Enthält',
        notContains: 'Enthält nicht',
        equals: 'Gleich',
        notEqual: 'Ungleich'
      },
      classId: 'Klassen-ID',
      group: 'Kontaktgruppe',
      applyFilters: 'Filter anwenden',
      clearFilters: 'Filter löschen',
      filterSub: 'Filter auf Tabellendaten anwenden',
      allClasses: 'Alle Klassen',
      allGroups: 'Alle Gruppen',
      manageContacts: 'Verwalten Sie alle Ihre Kontakte.',
      newContact: 'Neuer Kontakt',
      noContactsFound: 'Keine Kontakte gefunden',
      addSuccess: 'Kontakt wurde erfolgreich hinzugefügt!',
      updateSuccess: 'Kontakt wurde erfolgreich aktualisiert!',
      addedSuccessfully: 'wurde erfolgreich zu Ihren Kontakten hinzugefügt.',
      viewContact: 'Klicken Sie hier, um den Kontakt anzuzeigen',
      deleteConfirm: 'Möchten Sie {email} wirklich löschen?',
      sendEmail: 'E-Mail senden',
      emailTo: 'An: {email}',
      emailSubject: 'Betreff',
      emailMessage: 'Nachricht',
      cancel: 'Abbrechen',
      send: 'Senden',
      delete: 'Löschen',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phoneNumber: 'Telefonnummer',
      actions: 'Aktionen',
      edit: 'Bearbeiten'
    },
    addContact: {
      title: 'Kontakt hinzufügen',
      editTitle: 'Kontakt bearbeiten',
      Communication: 'Kommunikation',
      firstName: 'Vorname',
      lastName: 'Nachname',
      preferredName: 'Bevorzugter Name',
      email: 'E-Mail',
      noEmail: 'Keine E-Mail-Adresse verfügbar',
      phone: {
        primary: 'Haupttelefon',
        type: 'Telefontyp',
        numberPlaceholder: 'Telefonnummer eingeben',
        alternative: 'Alternative Telefonnummer',
        cell: 'Mobil',
        work: 'Arbeit',
        home: 'Privat',
        other: 'Andere',
      },
      address: {
        sameAsDelivery: 'Gleich wie Lieferadresse',
        billing: 'Rechnungsadresse'
      },
      requiredFieldsError: 'Bitte füllen Sie alle Pflichtfelder aus (Vorname, Nachname, E-Mail)',
      addressRequiredFieldsError: 'Bitte füllen Sie alle erforderlichen Adressfelder aus (Adresszeile 1, Stadt, Postleitzahl, Land, Hausnummer)',
      phoneRequiredError: 'Bitte füllen Sie alle Felder für die primäre Telefonnummer aus (Land, Nummer, Typ)',
      save: 'Speichern',
      cancel: 'Abbrechen'
    },
    socialMedia: {
      placeholders: {
        facebook: 'https://facebook.com/username',
        instagram: 'https://instagram.com/username',
        pinterest: 'https://pinterest.com/username',
        youtube: 'https://youtube.com/channel/username',
        tiktok: "https://tiktok.com/{'@'}username",
      },
    },
    incentives: {
      SUPERSTARTERINCENTIVEPROGRESS:
      {
        1: 'Beschreibung des Super Starter Anreizes - Stufe 1',
        2: 'Beschreibung des Super Starter Anreizes - Stufe 2',
        3: 'Beschreibung des Super Starter Anreizes - Stufe 3',
        4: 'Beschreibung des Super Starter Anreizes - Stufe 4',
        programDetails: '<div><b>Super Starter Programmdetails</b><p>Schließen Sie alle Stufen ab, um exklusive Belohnungen und Anerkennung zu erhalten!</p></div>',
        completeMsg:
        {
          1: 'Herzlichen Glückwunsch! Sie haben Stufe 1 abgeschlossen!',
          2: 'Großartige Arbeit! Sie haben Stufe 2 abgeschlossen!',
          3: 'Herausragende Leistung! Sie haben Stufe 3 abgeschlossen!',
          4: 'Herausragende Leistung! Sie haben Stufe 4 abgeschlossen!'
        }
      },
      TRIP2025INCENTIVEPROGRESS:
      {
        1: 'Beschreibung des Reiseanreizes 2025 - Silber',
        2: 'Beschreibung des Reiseanreizes 2025 - Gold',
        3: 'Beschreibung des Reiseanreizes 2025 - Platin',
        programDetails: '<div><b>Programmdetails im HTML-Format bereitstellen</b></div>',
        completeMsg:
        {
          1: 'Sie haben genug Punkte gesammelt, um auf die nächste Stufe aufzusteigen!',
          2: 'Sie haben genug Punkte gesammelt, um auf die nächste Stufe aufzusteigen!',
          3: 'Sie haben genug Punkte gesammelt, um auf die nächste Stufe aufzusteigen!'
        }
      },
      InqDsp_IncentiveCornerMSO:
      {
        1: 'Beschreibung des monatlichen Verkaufsangebots - Stufe 1',
        2: 'Beschreibung des monatlichen Verkaufsangebots - Stufe 2',
        3: 'Beschreibung des monatlichen Verkaufsangebots - Stufe 3',
        programDetails: '<div><b>Programmdetails im HTML-Format bereitstellen</b></div>',
        completeMsg:
        {
          1: 'Sie haben genug Punkte gesammelt, um auf die nächste Stufe aufzusteigen!',
          2: 'Sie haben genug Punkte gesammelt, um auf die nächste Stufe aufzusteigen!',
          3: 'Sie haben genug Punkte gesammelt, um auf die nächste Stufe aufzusteigen!'
        }
      },
      points: 'Punkte',
      travel: {
        title: 'Reiseanreiz',
        points: 'Punkte',
        programDetails: 'Programmdetails'
      },
      status: {
        inProgress: 'In Bearbeitung',
        completed: 'Abgeschlossen'
      }
    },
    tabs: {
      TasksContent: 'Aufgaben demnächst verfügbar.',
      ActivityContent: 'Aktivität demnächst verfügbar.',
    },
    MyDocuments: 'Meine Dokumente',
    CommissionStatements: 'Provisionsabrechnungen',
    TaxDocuments: 'Steuerdokumente',
    SearchByDocumentTitle: 'Nach Dokumenttitel suchen',
    IncentiveTracker: 'Anreiz-Tracker',
    IncentiveTrackerDescription: 'Überprüfen Sie Ihre Anreize und deren Fortschritt.',
    IncentiveTrackerSubtitle: 'Verfolge alle aktiven, geschlossenen und qualifizierten Anreize.',
    AllIncentives: 'Alle Anreize',
    LoadingIncentives: 'Anreize werden geladen...',
    NoIncentivesFound: 'Keine Anreize gefunden.',
    IncentiveName: 'Anreizname',
    OnTrack: 'Auf Kurs',
    Step: 'Stufe',
    Countdown: 'Countdown',
    StartDate: 'Startdatum',
    EndDate: 'Enddatum',
    Active: 'Aktiv',
    Closed: 'Geschlossen',
    Qualified: 'Qualifiziert',
    ReportDashboard: 'Team',
    CongratulationsMessage: 'Glückwunsch! Sie werden diesen Monat als {title} bezahlt.',
    ThisMonth: 'Dieser Monat',
    ThisYear: 'Dieses Jahr',
    PersonalTeamSales: 'Persönliche Team-Verkäufe',
    OrganizationSales: 'Organisationsverkäufe',
    TeamRecruits: 'Team-Rekrutierungen',
    TeamEndCount: 'Team-Endbestand',
    GettingStarted: 'Erste Schritte',
    MyPersonalTeam: 'Mein persönliches Team',
    AllLevels: 'Alle Ebenen',
    AllStatus: 'Alle Status',
    Inactive: 'Inaktiv',
    NewConsultants: 'Neue Berater',
    SeniorConsultantsAndTeamLeaders: 'Senior Berater und Teamleiter',
    AtRisk: 'Gefährdet',
    NotPaidAtTitle: 'Nicht auf Titelniveau bezahlt',
    CloseToLosingCareerSales: 'Kurz vor Verlust der Karriereumsätze',
    LessThan3PartiesBooked: 'Weniger als 3 Partys für nächsten Monat gebucht',
    RoadToSuccess: 'Weg zum Erfolg',
    CloseToPromoting: 'Kurz vor der Beförderung',
    CloseToEarningTravelIncentive: 'Kurz vor dem Erreichen eines Reiseanreizes',
    CloseToEarningSalesPromo: 'Kurz vor dem Erreichen einer Verkaufspromotion',
    Leaderboard: 'Bestenliste',
    Recruits: 'Rekrutierungen',
    QualifiedRecruits: 'Qualifizierte Rekrutierungen',
    CommissionableSales: 'Provisionsfähige Verkäufe',
    GenerateRecognitionImage: 'Anerkennungsbild generieren',
    RecognitionCongratulations: 'HERZLICHEN GLÜCKWUNSCH!',
    RecognitionFirstPlace: 'Erster Platz in meinem Team!',
    RecognitionOutstanding: 'Hervorragende Leistung bei {metric}!',
    Status: 'Status',
    Title: 'Titel',
    PersonalSales: 'Persönliche Verkäufe',
    ActiveConsultants: 'Aktive Berater',
    ViewAll: 'Alle anzeigen',
    DaysLeft: 'Tage übrig',
    Back: 'Zurück',
    SelectSection: 'Bereich auswählen',
    Progress: 'Fortschritt',
    TimeRemaining: 'Verbleibende Zeit',
    CurrentLevel: 'Aktuelle Stufe',
    RequirementProgress: 'Anforderungen Fortschritt',
    NoCommissionDocumentsFound: 'Keine Provisionsabrechnungen entsprechen Ihren Suchkriterien.',
    NoTaxDocumentsFound: 'Keine Steuerdokumente entsprechen Ihren Suchkriterien.',
    DocumentUrlExpired: 'Der Dokumentenlink ist abgelaufen. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
    Last3Months: 'Letzte 3 Monate',
    Last6Months: 'Letzte 6 Monate',
    Last12Months: 'Letzte 12 Monate',
    Last24Months: 'Letzte 24 Monate',
    AllTime: 'Alle Zeit',
    vatLiability: {
      VATLiability: 'Umsatzsteuerpflicht',
      VATLiabilityDescription: 'Fügen Sie Ihre Umsatzsteuer-ID oder Steuer-ID gemäß den Anweisungen Ihres Steuerberaters hinzu',
      VATInformation: 'Umsatzsteuerinformationen',
      VATIDType: 'ID-Typ',
      VATID: 'Umsatzsteuer-ID',
      TaxID: 'Steuer-ID',
      VATIDPlaceholder: 'Geben Sie Ihre Umsatzsteuer-ID oder Steuer-ID ein',
      VATIDPlaceholderDE: 'Geben Sie Ihre Umsatzsteuer-ID ein (z.B. DE123456789)',
      VATIDPlaceholderAT: 'Geben Sie Ihre Umsatzsteuer-ID ein (z.B. ATU12345678)',
      LoadingVatInformation: 'Umsatzsteuerinformationen werden geladen...',
      SaveError: 'Fehler beim Speichern der Umsatzsteuerinformationen',
      SaveSuccess: 'Umsatzsteuerinformationen erfolgreich gespeichert',
      TryAgain: 'Erneut Versuchen',
      Save: 'Speichern',
      Saving: 'Speichern...',
      RequiredField: 'Dieses Feld ist erforderlich',
      InvalidVATFormat: 'Ungültiges Umsatzsteuer-Format. Verwenden Sie DE + 9 Ziffern oder ATU + 8 Ziffern',
      InvalidVATFormatDE: 'Ungültiges deutsches Umsatzsteuer-Format. Verwenden Sie DE + 9 Ziffern (z.B., DE123456789)',
      InvalidVATFormatAT: 'Ungültiges österreichisches Umsatzsteuer-Format. Verwenden Sie ATU + 8 Ziffern (z.B., ATU12345678)',
      InvalidVATFormatFR: 'Ungültiges französisches Umsatzsteuer-Format. Verwenden Sie FR + 2 Buchstaben/Ziffern + 9 Ziffern (z.B., FRXX123456789)',
      InvalidVATFormatUS: 'Ungültiges Format. Verwenden Sie 5-15 alphanumerische Zeichen',
      InvalidTaxIDFormat: 'Steuer-ID muss mindestens 5 Zeichen haben',
      InvalidTaxIDFormatUS: 'Ungültiges US-Steuer-ID-Format. Verwenden Sie SSN (123-45-6789) oder EIN (12-3456789) oder 9 Ziffern',
      InvalidTaxIDFormatDE: 'Ungültiges deutsches Steuer-ID-Format. Verwenden Sie 11 Ziffern',
      InvalidTaxIDFormatFR: 'Ungültiges französisches Steuer-ID-Format. Verwenden Sie 9 Ziffern (SIREN)',
      InvalidTaxIDFormatAT: 'Ungültiges österreichisches Steuer-ID-Format. Verwenden Sie 9 Ziffern',
      ValidFormat: 'Gültiges Format erkannt',
      UnknownError: 'Ein unbekannter Fehler ist aufgetreten',
      VATCannotBeModified: 'Umsatzsteuerinformationen können nach der Festlegung nicht geändert werden',
      TaxIdNoInputRequired: 'Keine Eingabe erforderlich für TAXID'
    },
    myStory: {
      MyStoryHeader: 'Meine Geschichte',
      MyStorySubHeader: 'Teilen Sie Ihre persönliche Geschichte und Website mit Kunden',
      LoadingStory: 'Geschichte-Informationen werden geladen...',
      PageLoadError: 'Fehler beim Laden der Geschichte-Seite. Bitte versuchen Sie es erneut.',
      SaveError: 'Fehler beim Speichern der Geschichte',
      SaveErrorGeneric: 'Ein unerwarteter Fehler ist beim Speichern Ihrer Geschichte aufgetreten. Bitte versuchen Sie es erneut.',
      SaveSuccess: 'Geschichte erfolgreich gespeichert!',
      NetworkError: 'Netzwerkfehler aufgetreten. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
      ValidationError: 'Bitte korrigieren Sie die Validierungsfehler und versuchen Sie es erneut.',
      TryAgain: 'Erneut Versuchen',
      SaveStory: 'Geschichte Speichern',
      Saving: 'Speichern...',
      PersonalStorySection: 'Persönliche Geschichte',
      PersonalStory: 'Erzählen Sie Ihre Geschichte',
      StoryPlaceholder: 'Teilen Sie Ihre persönliche Geschichte, Ihren Hintergrund und was Sie als Berater einzigartig macht...',
      DesignMode: 'Design',
      HtmlMode: 'HTML',
      PreviewMode: 'Vorschau',
      HtmlPlaceholder: 'HTML-Code hier eingeben...',
      WebsiteSection: 'Website-Informationen',
      ConsultantWebsite: 'Berater-Website',
      LinkToConsultantWeb: 'Link zur Berater-Website:',
      WebsitePlaceholder: 'https://ihre-website.de',
      InvalidURL: 'Bitte geben Sie eine gültige URL ein (muss mit http:// oder https:// beginnen)'
    },
    companyName: {
      CompanyName: 'Firmenname',
      UpdateCompanyInfo: 'Aktualisieren Sie Ihren Firmennamen und Berater-URL',
      LoadingCompanyName: 'Firmeninformationen werden geladen...',
      PageLoadError: 'Fehler beim Laden der Firmeninformationen',
      SaveError: 'Fehler beim Speichern der Firmeninformationen',
      SaveErrorGeneric: 'Ein unerwarteter Fehler ist beim Speichern Ihrer Firmeninformationen aufgetreten. Bitte versuchen Sie es erneut.',
      SaveSuccess: 'Firmeninformationen erfolgreich gespeichert!',
      NetworkError: 'Netzwerkfehler aufgetreten. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
      ValidationError: 'Bitte korrigieren Sie die Validierungsfehler und versuchen Sie es erneut.',
      TryAgain: 'Erneut Versuchen',
      SaveCompanyName: 'Firmenname Speichern',
      Saving: 'Speichern...',
      BusinessNameSection: 'Geschäftsinformationen',
      BusinessName: 'Geschäftsname',
      BusinessNamePlaceholder: 'Geben Sie Ihren Geschäftsnamen ein',
      BusinessNameHelp: 'Dieser Name wird in Ihrer Berater-URL und Ihrem öffentlichen Profil verwendet.',
      BusinessNameRequired: 'Geschäftsname ist erforderlich',
      BusinessNameTooShort: 'Geschäftsname muss mindestens 2 Zeichen lang sein',
      BusinessNameTooLong: 'Geschäftsname darf 100 Zeichen nicht überschreiten',
      BusinessNameInvalidCharacters: 'Geschäftsname darf nur Standard-Buchstaben, Zahlen und Symbole enthalten',
      BusinessNameAlreadyExists: 'Dieser Geschäftsname ist bereits vergeben. Bitte wählen Sie einen anderen Namen.',
      ConsultantUrlSection: 'Berater-URL',
      ConsultantUrl: 'Ihre Berater-URL',
      UrlPlaceholder: 'ihr-geschaeftsname',
      UrlHelp: 'Dies ist die Webadresse, die Kunden verwenden werden, um Ihre Beraterseite zu finden.',
      SearchVisibilitySection: 'Suchsichtbarkeit',
      OptOutFromSearch: 'Nicht mehr in den Berater-Suchergebnissen angezeigt werden',
      OptOutHelp: 'Wenn aktiviert, wird Ihr Profil nicht in öffentlichen Berater-Suchergebnissen angezeigt.',
      UpdateOptOut: 'Aktualisieren',
      Updating: 'Aktualisierung...',
      OptOutUpdateSuccess: 'Suchsichtbarkeitseinstellungen erfolgreich aktualisiert!',
      OptOutUpdateError: 'Fehler beim Aktualisieren der Suchsichtbarkeit',
      OptOutUpdateErrorMessage: 'Ein Fehler ist beim Aktualisieren Ihrer Suchsichtbarkeitseinstellungen aufgetreten. Bitte versuchen Sie es erneut.',
      UnauthorizedError: 'Sie sind nicht berechtigt, diese Aktion auszuführen. Bitte melden Sie sich erneut an.',
      TimeoutError: 'Die Anfrage ist abgelaufen. Bitte versuchen Sie es erneut.'
    },
    FrenchContribution: 'Französische Steuerdokumente',
    walletInformation: {
      WalletInformation: 'Wallet-Informationen',
      WalletDescription: 'Verwalten Sie Ihre Kreditkarteninformationen für sichere Zahlungen',
      CardName: 'Kartenname',
      CardNumber: 'Kartennummer',
      PayPalAccount: 'PayPal-Konto',
      PayPalEmail: 'PayPal-E-Mail',
      ExpirationDate: 'Ablaufdatum',
      NameOnCard: 'Name auf der Karte',
      CVV: 'CVV',
      AddCard: 'Karte hinzufügen',
      EditCard: 'Karte bearbeiten',
      DeleteCard: 'Karte löschen',
      ExtendCard: 'Karte verlängern',
      SetAsDefault: 'Als Standard festlegen',
      DefaultCard: 'Standardkarte',
      ExpiredCard: 'Abgelaufene Karte',
      ExpiresOn: 'Läuft ab am',
      CardType: 'Kartentyp',
      LastFour: 'Letzte Vier',
      NoCardsFound: 'Keine Karten gefunden',
      NoCardsDescription: 'Sie haben noch keine Zahlungsmethoden hinzugefügt.',
      LoadingCards: 'Zahlungsmethoden werden geladen...',
      AddingCard: 'Karte wird hinzugefügt...',
      NameOnCardRequired: 'Name auf der Karte ist erforderlich',
      CVVRequired: 'CVV ist erforderlich',
      InvalidCardNumber: 'Ungültige Kartennummer',
      InvalidExpirationDate: 'Ungültiges Ablaufdatum',
      CardExpired: 'Karte ist abgelaufen',
      CardNumberFormat: 'Kartennummer muss 13-19 Ziffern haben',
      ExpirationFormat: 'MM/JJJJ Format verwenden',
      CVVFormat: 'CVV muss 3-4 Ziffern haben',
      ConfirmDeleteCard: 'Sind Sie sicher, dass Sie diese Karte löschen möchten?',
      ConfirmDeleteCardMessage: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      Cancel: 'Abbrechen',
      Confirm: 'Bestätigen',
      Save: 'Speichern',
      Close: 'Schließen',
      Edit: 'Bearbeiten',
      Delete: 'Löschen',
      Extend: 'Verlängern',
      UsePaymentMethod: 'Zahlungsmethode verwenden',
      NewExpirationDate: 'Neues Ablaufdatum',
      ExtendCardTitle: 'Kartengültigkeit verlängern',
      ExtendCardDescription: 'Ablaufdatum für diese Karte aktualisieren',
      UpdateCardExpiration: 'Kartenablauf aktualisieren',
      UpdateExpiration: 'Ablauf aktualisieren',
      NoDefaultWarning: 'Keine Standard-Zahlungsmethode ausgewählt. Bitte legen Sie eine Standardkarte für Transaktionen fest.',
      TryAgain: 'Erneut versuchen',
      SetAsPrimary: 'Als primäre Zahlungsmethode festlegen',
      SetAsPrimaryDescription: 'Diese zu Ihrer Standard-Zahlungsmethode für Transaktionen machen',
      AccountName: 'Kontoname',
      Usage: 'Verwendung',
      AccountNameRequired: 'Kontoname ist erforderlich',
      UsageRequired: 'Verwendung ist erforderlich',
      Name: 'Name',
      HolderName: 'Karteninhaber',
      Use: 'Verwendung',
      ProcessingCard: 'Karteninformationen werden verarbeitet...'
    },
    RecruitmentSearch: 'Rekrutierungssuche',
    RecruitmentSearchDescription: 'Kontrollieren Sie Ihre Sichtbarkeit in Berater-Rekrutierungssuchen',
    VisibilitySettings: 'Sichtbarkeitseinstellungen',
    ShowName: 'Name Anzeigen',
    ShowLocation: 'Standort Anzeigen',
    ShowPhoto: 'Foto Anzeigen',
    ShowEmail: 'E-Mail Anzeigen',
    ShowLandline: 'Festnetztelefon Anzeigen',
    ShowMobile: 'Mobiltelefon Anzeigen',
    LoadingVisibilitySettings: 'Sichtbarkeitseinstellungen werden geladen...',
    LoadError: 'Fehler beim Laden der Einstellungen',
    TryAgain: 'Erneut Versuchen',
    SaveError: 'Fehler beim Speichern der Einstellungen',
    Save: 'Speichern',
    Cancel: 'Abbrechen',
    ChangesSaved: 'Änderungen erfolgreich gespeichert',
    ChangesDiscarded: 'Änderungen verworfen'
  },
  thankYou: {
    PageHeader: 'Vielen Dank für Ihre Bestellung!',
    SubHeader: 'Ihre Bestellung wurde erfolgreich aufgegeben. Eine Bestätigungs-E-Mail wurde an Ihre angegebene E-Mail-Adresse gesendet.',
    DetailsAboutOrder: 'Details zu Ihrer Bestellung',
    orderNumber: 'Bestellnummer:',
    PaymentAmount: 'Zahlungsbetrag',
    YourItems: 'Ihre Artikel',
    shippingCost: 'Versandkosten',
    total: 'Gesamtsumme inkl. MwSt.',
    totalTaxAmountInclude: 'Enthaltene Steuer'
  },
   orderList: {
    AllOrderTypes: 'Alle Bestellungstypen',
    AllViews: 'Alle Bestellungen',
    ApplyFilterButton: 'Filter anwenden',
    BetweenAnd: 'Und',
    ClearFilterButton: 'Filter löschen',
    searchPlaceholder: 'Bestellungen suchen...',
    orderCount: '{count} Bestellungen',
    CommissionableValue: 'CV',
    ColumnListHeader: 'Spalten',
    ColumnListSubHeader: 'Aktivieren und ordnen Sie die Spalten, die Sie in Ihrer Bestellliste sehen möchten',
    ColumnOperandBeginsWith: 'Beginnt mit',
    ColumnOperandBetween: 'Zwischen',
    ColumnOperandContains: 'Enthält',
    ColumnOperandEquals: 'Ist gleich',
    ColumnOperandGreaterThan: 'Größer als',
    ColumnOperandGreaterThanOrEqual: 'Größer oder gleich',
    ColumnOperandLessThan: 'Kleiner als',
    ColumnOperandLessThanOrEqual: 'Kleiner oder gleich',
    ColumnOperandNotEquals: 'Ist nicht gleich',
    ColumnOperandSelectColumn: 'Spalte auswählen',
    CreateRMA: 'RMA erstellen',
    Email: 'E-Mail',
    ExportButton: 'Exportieren',
    ExportFileName: 'MeineBestellungen',
    FilterByColumn: 'Nach Spaltenwert filtern',
    FilterByOrderType: 'Nach Bestellungstyp filtern',
    FilterByView: 'Ansicht',
    GridFilterHeader: 'Filter',
    GridFilterSubHeader: 'Filter auf Ihre Bestellliste anwenden',
    LastName: 'Nachname',
    MakeReturn: 'Rücksendung erstellen',
    MasterOrderId: 'Bestellreferenz',
    NoColumnSelected: 'Spalte zum Suchen auswählen',
    NoTrackingNumber: 'Keine Sendungsverfolgungsnummer angegeben',
    OrderDate: 'Bestelldatum',
    OrderId: 'Bestellnummer',
    Orders: 'Meine Bestellungen',
    AllOrders: 'Alle Bestellungen',
    OrderTotal: 'Gesamtbetrag',
    OrderType: 'Bestellungstyp',
    PaidView: 'Bezahlte Bestellungen',
    PlaceHolderSearchFilter: 'Suchen nach',
    PlaceHolderSearchFilterDate: 'Nach Datum suchen',
    PlaceHolderSearchFilterNumber: 'Nach Nummer suchen',
    PlaceHolderSearchFilterSecondDate: 'Nach zweitem Datum suchen',
    PlaceHolderSearchFilterSecondNumber: 'Nach zweiter Nummer suchen',
    OrderSubHeader: 'Behalten Sie den Überblick über alle Ihre Bestellungen.',
    TrackingNumber: 'Sendungsverfolgungsnummer',
    UnpaidView: 'Unbezahlte Bestellungen',
    ViewInvoice: 'Rechnung anzeigen',
    clearAllFilters: 'Alle Filter löschen',
    clearFilter: 'Filter löschen',
    Page: 'Seite',
    Of: 'von',
    Previous: 'Zurück',
    Next: 'Weiter',
    address: {
      // Page headers
      AddressManagement: 'Adressverwaltung',
      ManageAddresses: 'Verwalten Sie Ihre Rechnungs-, Versand- und Postadressen',
      LoadingAddresses: 'Adressinformationen werden geladen...',
      PageLoadError: 'Adressinformationen konnten nicht geladen werden. Bitte versuchen Sie es erneut.',

      // Address types
      BillingAddress: 'Rechnungsadresse',
      DeliveryAddress: 'Lieferadresse',
      MailingAddress: 'Postadresse',

      // Actions
      AddNew: 'Neue hinzufügen',
      Change: 'Ändern',
      UseExisting: 'Vorhandene verwenden',
      Save: 'Speichern',
      Saving: 'Speichern...',
      Cancel: 'Abbrechen',
      TryAgain: 'Erneut versuchen',

      // Form labels
      ContactInfo: 'Kontaktinformationen',
      AddressDetails: 'Adressdetails',
      FirstName: 'Vorname',
      LastName: 'Nachname',
      AddressLine1: 'Adresszeile 1',
      AddressLine2: 'Adresszeile 2 (Optional)',
      City: 'Stadt',
      StateCode: 'Bundesland/Provinz',
      PostalCode: 'Postleitzahl',
      CountryCode: 'Land',

      // Form titles
      AddNewAddress: 'Neue Adresse hinzufügen',
      EditAddress: 'Adresse bearbeiten',
      SelectExistingAddress: 'Vorhandene Adresse auswählen',

      // Status messages
      NoAddressSet: 'Keine Adresse festgelegt',
      NoSavedAddresses: 'Keine gespeicherten Adressen verfügbar',

      // Validation messages
      FirstNameRequired: 'Vorname ist erforderlich',
      LastNameRequired: 'Nachname ist erforderlich',
      AddressLine1Required: 'Adresszeile 1 ist erforderlich',
      CityRequired: 'Stadt ist erforderlich',
      StateCodeRequired: 'Bundesland/Provinz ist erforderlich',
      PostalCodeRequired: 'Postleitzahl ist erforderlich',
      CountryCodeRequired: 'Land ist erforderlich',
      ValidationError: 'Bitte korrigieren Sie die Validierungsfehler und versuchen Sie es erneut',

      // Success/Error messages
      SaveSuccess: 'Adressinformationen erfolgreich gespeichert!',
      SaveError: 'Fehler beim Speichern der Adressinformationen',
      SaveErrorGeneric: 'Beim Speichern ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
      NetworkError: 'Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.'
    }
  },
  dashboard: {
    progress: {
      MyProgress: 'Mein Fortschritt',
      Progress: 'Fortschritt',
      ProgressInfo: 'Übersicht über die Leistungskennzahlen.',
      MonthlyOverview: 'Dieser Monat',
      Overview: 'Übersicht',
      MonthlyProgressInfo: 'Übersicht über die Leistung in diesem Monat.',
      TotalRecruitmentCount: 'Gesamtzahl der Rekrutierungen',
      CareerSales: 'Karriere-Umsätze',
      UnsubmittedPartyOrder: 'Nicht eingereichte Party-Bestellungen',
      NextPromotionLevel: 'Nächste Beförderungsstufe',
      NextPromotionProgress: 'Sie sind {0} von Ihrer nächsten Beförderungsstufe entfernt!',
      PROMOTIONPROGRESS_PSV: 'Persönliches Verkaufsvolumen',
      PROMOTIONPROGRESS_PSV_MESSAGE: 'Sie sind {0} vom Erreichen der nächsten Stufe entfernt!',
      PROMOTIONPROGRESS_ACTIVELINES: 'Aktive Linien',
      PROMOTIONPROGRESS_ACTIVELINES_MESSAGE: 'Sie benötigen {0} weitere aktive Linien, um die nächste Stufe zu erreichen!',
      PROMOTIONPROGRESS_TEAMSALES: 'Team-Umsätze',
      PROMOTIONPROGRESS_TEAMSALES_MESSAGE: 'Ihr Team benötigt {0} mehr Umsatz, um aufzusteigen!',
      PROMOTIONPROGRESS_GEN1DIRECTORS: 'Gen 1 Direktoren',
      PROMOTIONPROGRESS_GEN1DIRECTORS_MESSAGE: 'Sie benötigen {0} weitere Gen 1 Direktoren, um die nächste Stufe zu erreichen!',
      PROMOTIONPROGRESS_EXECDIRECTORTEAMS: 'Executive Director Teams',
      PROMOTIONPROGRESS_EXECDIRECTORTEAMS_MESSAGE: 'Sie benötigen {0} weitere Executive Director Teams, um aufzusteigen!',
      PROMOTIONPROGRESS_ORGVOLUME: 'Organisationsvolumen',
      PROMOTIONPROGRESS_ORGVOLUME_MESSAGE: 'Ihre Organisation benötigt {0} mehr Volumen, um die nächste Stufe zu erreichen!',
      RequirementCompleted: 'Anforderung erfüllt! Herzlichen Glückwunsch!',
      MonthlyRecruitmentCount: 'Rekrutierungszahl',
      MonthlySales: 'Monatlicher Umsatz',
      MonthlyQV: 'Monatliches Qualifizierungsvolumen',
      CommissionRate: 'Provisionssatz',
      QV: 'PQP'
    },
    invoice: {
      orderNumber: 'Bestellnummer',
      eventId: 'Veranstaltungs-ID',
      customerName: 'Kundenname',
      invoiceNumber: 'Rechnungsnummer',
      amount: 'Betrag',
      status: 'Rechnungsstatus',
      issueDate: 'Ausstellungsdatum',
      reads: 'Gelesen',
      hints: 'Hinweise',
      title: 'Offene Bestellungen',
      description: 'Verfolgen Sie offene Rechnungen, stornieren oder senden Sie Rechnungen bei Bedarf erneut.',
      allInvoices: 'Alle Rechnungen',
      read: 'Gelesen',
      sent: 'Gesendet',
      Issued: 'Ausgestellt',
      NotPaid: 'Nicht bezahlt',
      Paid: 'Bezahlt',
      GridFilterHeader: 'Rechnungen filtern',
      GridFilterSubHeader: 'Verwenden Sie die Optionen unten, um die Rechnungsliste zu filtern',
      FilterByStatus: 'Nach Status filtern',
      FilterByPeriod: 'Nach Zeitraum filtern',
      AllStatuses: 'Alle Status',
      AllPeriods: 'Alle Zeiträume',
      Last30Days: 'Letzte 30 Tage',
      Last60Days: 'Letzte 60 Tage',
      Last90Days: 'Letzte 90 Tage',
      CancelInvoice: 'Rechnung stornieren',
      ResendInvoice: 'Rechnung erneut senden',
      ActionsUnavailableCanceled: 'Diese Rechnung wurde storniert',
      ActionsUnavailablePaid: 'Diese Rechnung wurde bezahlt',
      Resend: 'Erneut senden',
      orders: 'Bestellungen',
      noInvoicesFound: 'Keine Rechnungen für die ausgewählten Kriterien gefunden.',
      Cancelled: 'Storniert',
      Read: 'Gelesen'
    },
    openParties: {
      title: 'Offene Partys',
      description: 'Verwalten Sie Ihre bevorstehenden Partys und Veranstaltungen.',
      parties: 'Partys',
      CreateParty: 'Party erstellen',
      DaysTilParty: 'Tage bis zur Party',
      NumberOfCarts: 'Anzahl der Warenkörbe',
      ExternalOrders: 'Externe Bestellungen',
      day: 'Tag',
      days: 'Tage'
    },
    incentives: {
      SUPERSTARTERINCENTIVEPROGRESS:
      {
        1: 'Beschreibung des Super Starter Anreizes - Level 1',
        2: 'Beschreibung des Super Starter Anreizes - Level 2',
        3: 'Beschreibung des Super Starter Anreizes - Level 3',
        4: 'Beschreibung des Super Starter Anreizes - Level 4',
        programDetails: '<div><b>Super Starter Programmdetails</b><p>Schließen Sie alle Level ab, um exklusive Belohnungen und Anerkennung zu erhalten!</p></div>',
        completeMsg:
        {
          1: 'Herzlichen Glückwunsch! Sie haben Level 1 abgeschlossen!',
          2: 'Großartige Arbeit! Sie haben Level 2 abgeschlossen!',
          3: 'Herausragende Leistung! Sie haben Level 3 abgeschlossen!',
          4: 'Herausragende Leistung! Sie haben Level 4 abgeschlossen!'
        }
      },
      TRIP2025INCENTIVEPROGRESS:
      {
        1: 'Beschreibung des 2025 Reise-Anreizes - Silber',
        2: 'Beschreibung des 2025 Reise-Anreizes - Gold',
        3: 'Beschreibung des 2025 Reise-Anreizes - Platin',
        programDetails: '<div><b>Programmdetails im HTML-Format bereitstellen</b></div>',
        completeMsg:
        {
          1: 'Sie haben genug Punkte gesammelt, um zum nächsten Level aufzusteigen!',
          2: 'Sie haben genug Punkte gesammelt, um zum nächsten Level aufzusteigen!',
          3: 'Sie haben genug Punkte gesammelt, um zum nächsten Level aufzusteigen!'
        }
      },
      InqDsp_IncentiveCornerMSO:
      {
        1: 'Beschreibung des monatlichen Verkaufsangebots - Level 1',
        2: 'Beschreibung des monatlichen Verkaufsangebots - Level 2',
        3: 'Beschreibung des monatlichen Verkaufsangebots - Level 3',
        programDetails: '<div><b>Programmdetails im HTML-Format bereitstellen</b></div>',
        completeMsg:
        {
          1: 'Sie haben genug Punkte gesammelt, um zum nächsten Level aufzusteigen!',
          2: 'Sie haben genug Punkte gesammelt, um zum nächsten Level aufzusteigen!',
          3: 'Sie haben genug Punkte gesammelt, um zum nächsten Level aufzusteigen!'
        }
      },
      points: 'Punkte',
      travel: {
        title: 'Reise-Anreiz',
        points: 'Punkte',
        programDetails: 'Programmdetails'
      },
      status: {
        inProgress: 'In Bearbeitung',
        completed: 'Abgeschlossen'
      }
    }
  },
  richTextEditor: {
    designMode: 'Design',
    htmlMode: 'HTML',
    previewMode: 'Vorschau',
    normalText: 'Normaler Text',
    heading1: 'Überschrift 1',
    heading2: 'Überschrift 2',
    heading3: 'Überschrift 3',
    paragraph: 'Absatz',
    textColor: 'Textfarbe',
    backgroundColor: 'Hintergrundfarbe',
    createLink: 'Link erstellen',
    removeLink: 'Link entfernen',
    enterUrl: 'URL eingeben:',
    htmlPlaceholder: 'HTML-Code hier eingeben...'
  },
  contracts: {
    title: 'Verträge',
    description: 'Sehen Sie eine Liste der Verträge, die Sie unterzeichnet haben',
    name: 'Name',
    version: 'Version',
    deliveredOn: 'Geliefert Am',
    signByDate: 'Unterzeichnungsfrist',
    loading: 'Verträge werden geladen...',
    noContracts: 'Keine Verträge Gefunden',
    noContractsDescription: 'Sie haben noch keine Verträge unterzeichnet.'
  },
  webshopSettings: {
    // Page headers
    WebshopSettings: 'Webshop-Einstellungen',
    ManageWebshopSettings: 'Ermöglicht Beratern die Verwaltung von Webshop-Einstellungen, Zahlungsmethoden und Verlängerungen',
    LoadingWebshopSettings: 'Webshop-Einstellungen werden geladen...',
    PageLoadError: 'Webshop-Einstellungen konnten nicht geladen werden. Bitte versuchen Sie es erneut.',

    // Plan Selection
    chooseYourPlan: 'Wählen Sie Ihren Plan',
    manageYourPlan: 'Verwalten Sie Ihren Plan',
    activeSubscription: 'Aktives Abonnement',
    start90DaysTrial: 'Starten Sie heute Ihre 90-tägige kostenlose Testversion',
    startFreeTrial: 'Kostenlose Testversion Starten',
    trialPeriod: 'Testzeitraum',
    noPlanSelected: 'Kein Plan Ausgewählt',
    noPlanSelectedMessage: 'Klicken Sie unten auf einen Plan, um ihn für das Ende Ihres Testzeitraums auszuwählen.',
    noPlanSelectedAssuranceMessage: 'Ohne Auswahl eines Plans werden Sie weder belastet noch automatisch eingeschrieben.',
    trialActiveMessage: 'Sie sind derzeit im Testprogramm aktiv.',
    trialPlanSelectionNearEndMessage: 'Sie können Ihren Plan ab 10 Tagen vor dem Ende Ihres Testzeitraums auswählen ({countdown}). Ohne Auswahl eines Plans werden Sie weder belastet noch automatisch eingeschrieben.',
    countdownInOneWeek: 'in 1 Woche',
    countdownInWeeks: 'in {count} Wochen',
    countdownInOneDay: 'in 1 Tag',
    countdownInDays: 'in {count} Tagen',
    currentSelection: 'Aktuelle Auswahl',
    plan: 'Plan',
    trialSelectionMessage: 'Sie können Ihren Plan jederzeit ändern oder sich abmelden, bevor Ihre Testversion endet. Ihre Karte wird nicht belastet, wenn kein Plan ausgewählt ist.',
    trialEndsOn: 'Ihre Testphase endet am',
    continueToPurchase: 'Weiter zum Kauf',
    currentPaymentMethod: 'Aktuelle Zahlungsmethode',
    manageBilling: 'Abrechnung Verwalten',
    selectPaymentMethod: 'Zahlungsmethode Auswählen',
    addNewCard: 'Neue Karte Hinzufügen',
    processingCard: 'Karte wird verarbeitet...',
    cancel: 'Abbrechen',
    select: 'Auswählen',
    current: 'Aktuell',
    pending: 'Ausstehend',
    monthly: 'Monatlich',
    quarterly: 'Vierteljährlich',
    biAnnual: 'Halbjährlich',
    annual: 'Jährlich',
    savePercent: '{savings}% sparen',
    visa: 'VISA',
    expires: 'Läuft ab',
    processing: 'Wird verarbeitet...',
    selectAPlan: 'Wählen Sie einen Plan',
    confirmPlanSelection: 'Planauswahl Bestätigen',
    confirmPlanMessage: 'Sind Sie sicher, dass Sie diesen Plan auswählen möchten? Dies wird Ihr Verlängerungsplan sein, wenn Ihre Testversion endet.',
    confirm: 'Bestätigen',
    pendingChange: 'Ausstehende Änderung',
    pendingChangeMessage: 'Sie können Ihren Plan jederzeit ändern. Änderungen werden am {renewalDate} wirksam.',
    currentPlan: 'Aktueller Plan',
    month: 'Monat',
    sixMonths: '6 Monate',
    year: 'Jahr',
    frequency: {
      perMonth: 'pro Monat',
      everyThreeMonths: 'alle 3 Monate',
      everySixMonths: 'alle 6 Monate',
      perYear: 'pro Jahr',
    },
    planChangeMessage: 'Sie können Ihren Plan jederzeit ändern. Änderungen werden in Ihrem nächsten Abrechnungszyklus wirksam.',
    upgradeMessage: 'Sie können jederzeit auf einen anderen Plan upgraden. Änderungen werden in Ihrem nächsten Abrechnungszyklus wirksam.',
    subscriptionActive: 'Ihr Abonnement ist aktiv',
    subscriptionEndsOn: 'Ihr Abonnement endet am: {renewalDate}',
    nextBilling: 'Nächste Abrechnung',
    cancelPendingChange: 'Ausstehende Änderung Abbrechen',
    cancelPendingChangeTitle: 'Ausstehende Änderung Abbrechen',
    cancelPendingChangeMessage: 'Sind Sie sicher, dass Sie Ihre ausstehende Planänderung abbrechen möchten? Ihr aktueller Plan bleibt aktiv.',
    confirmCancel: 'Abbruch Bestätigen',
    cancelSubscription: 'Abonnement Kündigen',
    cancelSubscriptionTitle: 'Abonnement Kündigen',
    cancelSubscriptionMessage: 'Ihr Abonnement wird nach dem Verlängerungsdatum nicht erneuert. Sind Sie sicher, dass Sie kündigen möchten?',
    confirmCancelSubscription: 'Kündigung Bestätigen',
    subscriptionCancelledMessage: 'Sie haben Ihr Abonnement gekündigt. Ihr Abonnement wird nach dem Verlängerungsdatum nicht erneuert. Sie können sich nach Ablauf Ihres aktuellen Abonnements erneut anmelden.',
    deleteCardTitle: 'Karte Löschen',
    deleteCardMessage: 'Sind Sie sicher, dass Sie diese Karte löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    confirmDeleteCard: 'Karte Löschen',

    // Expired/No Active Subscription State
    noActiveSubscription: 'Kein Aktives Abonnement',
    noCurrentSubscription: 'Kein Aktuelles Abonnement',
    noCurrentSubscriptionMessage: 'Wählen Sie unten einen Plan aus, um zu beginnen. Sie können jederzeit ändern oder kündigen.',
    invalidPaymentMethod: 'Ungültige Zahlungsmethode',
    invalidPaymentMethodMessage: 'Fügen Sie eine Zahlungsmethode hinzu oder ändern Sie sie.',
    paymentDue: 'Zahlung fällig',
    renewalProcessingTitle: 'Verlängerung wird verarbeitet',
    renewalProcessingMessage: 'Ihre Verlängerungsänderung wird derzeit verarbeitet. Bitte warten Sie, bis diese Aktualisierung abgeschlossen ist.',
    renewalProcessingPendingLabel: 'Ihre Verlängerung wird verarbeitet. Plan- und Abrechnungsaktionen sind vorübergehend nicht verfügbar.',
    getStartedToday: 'Beginnen Sie heute',
    choosePlanToBegin: 'Wählen Sie einen Plan, um Ihr Abonnement zu beginnen',
    paymentSetupRequired: 'Zahlungseinrichtung Erforderlich',
    paymentSetupMessage: 'Sie werden aufgefordert, nach Auswahl Ihres Plans eine Zahlungsmethode hinzuzufügen. Keine Gebühren bis zur Bestätigung.',
    reenroll: 'Erneut Anmelden',

    // Actions
    ChangePlan: 'Plan Ändern',
    Enroll: 'Anmelden',
    RenewEnrollment: 'Anmeldung Verlängern',
    Reenroll: 'Erneut Anmelden',
    TerminateOnlineShop: 'Online-Shop Beenden',
    Unenroll: 'Abmelden',
    UpdatePendingChanges: 'Ausstehende Änderungen Aktualisieren',
    RevertPendingChanges: 'Ausstehende Änderungen Rückgängig Machen',
    TryAgain: 'Erneut Versuchen',

    // Current Plan Section
    CurrentPlan: 'Aktuelle Plan-Informationen',
    PlanName: 'Plan-Name',
    RenewalFrequency: 'Verlängerungshäufigkeit',
    ProcessStatus: 'Prozessstatus',
    NextRenewalDate: 'Nächstes Verlängerungsdatum',

    // Current Configuration Section
    CurrentConfiguration: 'Aktuelle Konfiguration',
    CurrentProgramName: 'Aktueller Programmname',
    CurrentOptionalPrograms: 'Aktuelle Optionale Programme',
    RenewalDate: 'Verlängerungsdatum',
    ExpiresOn: 'Läuft Ab Am',

    // Current Program Section (legacy)
    CurrentProgram: 'Aktuelle Programm-Informationen',
    RequiredProgram: 'Erforderliches Programm',
    OptionalPrograms: 'Optionale Programme',
    NoOptionalPrograms: 'Keine optionalen Programme',

    // Pending Changes Section
    PendingChanges: 'Ausstehende Änderungen',
    Current: 'Aktuelle Konfiguration',
    Pending: 'Ausstehende Konfiguration',
    PendingConfiguration: 'Ausstehende Konfiguration',
    Program: 'Programm',
    PeriodName: 'Periodenname',
    FuturePeriodName: 'Zukünftiger Periodenname',
    FutureProgramName: 'Zukünftiger Programmname',
    FutureOptionalPrograms: 'Zukünftige Optionale Programme',
    EffectiveDate: 'Gültigkeitsdatum',

    // Next Payment Section
    NextPayment: 'Nächste Zahlung',
    RenewalOverdue: 'Verlängerung Überfällig',
    AccountOverdueMessage: 'Ihre Kontoverlängerung ist überfällig. Bitte aktualisieren Sie Ihre Zahlungsinformationen.',
    CardWillBeCharged: 'Ihre Karte wird belastet',

    // Payment Information Section (legacy)
    PaymentInformation: 'Zahlungsinformationen',
    NextChargeAmount: 'Nächster Rechnungsbetrag',
    NextChargeDate: 'Nächstes Rechnungsdatum',

    // Secondary Plan Section
    SecondaryPlan: 'Sekundäre Plan-Informationen',
    SecondaryPlanName: 'Sekundärer Plan-Name',
    SecondaryStatus: 'Sekundärer Status',
    SecondaryRenewalDate: 'Sekundäres Verlängerungsdatum',
    SecondaryRenewalConfigurationPending: 'Verlängerungskonfigurationsstatus ist ausstehend',

    // Configuration Status Messages
    RenewalConfigurationPending: 'Verlängerungskonfiguration Ausstehend',
    RenewalConfigurationPendingMessage: 'Ihre Verlängerungskonfiguration wird derzeit verarbeitet. Bitte schauen Sie später noch einmal nach.',
    NoActivePlan: 'Kein Aktiver Plan',
    NoActivePlanMessage: 'Sie sind derzeit in keinem Plan eingeschrieben. Klicken Sie auf "Erneut Anmelden", um einem Verlängerungsprogramm beizutreten.',

    // Status values
    StatusActive: 'Aktiv',
    StatusPending: 'Ausstehend',
    StatusExpired: 'Abgelaufen',
    StatusCancelled: 'Storniert',
    StatusProcessing: 'Wird Verarbeitet',

    // Success/Error messages
    SaveSuccess: 'Webshop-Einstellungen erfolgreich aktualisiert!',
    SaveError: 'Fehler beim Aktualisieren der Webshop-Einstellungen',
    SaveErrorGeneric: 'Ein Fehler ist beim Aktualisieren aufgetreten. Bitte versuchen Sie es erneut.',
    NetworkError: 'Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',

    // Change Plan Modal
    ChangePlanModalTitle: 'Plan Ändern',
    ChangePlanModalDescription: 'Wählen Sie eine neue Verlängerungshäufigkeit und Programme für Ihren Plan',
    SelectRenewalFrequency: 'Verlängerungshäufigkeit Auswählen',
    RenewalFrequencyPlaceholder: 'Verlängerungshäufigkeit wählen...',
    LoadingRenewalFrequencies: 'Verlängerungshäufigkeiten werden geladen...',
    NoRenewalFrequenciesAvailable: 'Keine Verlängerungshäufigkeiten verfügbar',
    RequiredPrograms: 'Erforderliche Programme',
    OptionalProgramsSelection: 'Optionale Programme',
    LoadingPrograms: 'Programme werden geladen...',
    NoProgramsAvailable: 'Keine Programme verfügbar',
    Kits: 'Kits',
    LoadingKits: 'Kits werden geladen...',
    NoKitsAvailable: 'Keine Kits für die ausgewählten Programme verfügbar',
    SelectProgram: 'Bitte wählen Sie ein Programm aus, um verfügbare Kits zu sehen',
    Cancel: 'Abbrechen',
    SaveChanges: 'Änderungen Speichern',
    ChangePlanSuccess: 'Plan erfolgreich geändert!',
    ChangePlanError: 'Fehler beim Ändern des Plans',

    // Revert Confirmation Modal
    ConfirmRevert: 'Änderungen Rückgängig Machen Bestätigen',
    ConfirmRevertMessage: 'Sind Sie sicher, dass Sie die ausstehenden Änderungen rückgängig machen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    ConfirmRevertButton: 'Ja, Änderungen Rückgängig Machen',

    // Select Payment Method Modal
    SelectPaymentMethod: 'Zahlungsmethode Auswählen',
    SelectPaymentDescription: 'Wählen Sie die Zahlungsmethode, die Sie für Verlängerungszahlungen verwenden möchten',
    LoadingPaymentMethods: 'Zahlungsmethoden werden geladen...',
    NoPaymentMethodsAvailable: 'Keine Zahlungsmethoden verfügbar. Bitte fügen Sie zuerst eine Zahlungsmethode hinzu.',
    CurrentRenewalCard: 'Aktuelle Verlängerung',
    CardNumber: 'Kartennummer',
    ExpirationDate: 'Ablaufdatum',
    HolderName: 'Name des Karteninhabers',
    ConfirmSelection: 'Auswahl Bestätigen',

    // Renewal Countdown Notification
    RenewalReminder: 'Verlängerungserinnerung',
    RenewalReminderMessage: 'Ihre Verlängerung steht in {days} Tagen an!'
  },
  account: {
    ChooseOption: 'Wählen Sie Ihre Option',
    ChooseDescription: 'Haben Sie bereits ein Konto bei uns?',
    HaveAccount: 'Ja, ich habe ein Konto',
    CreateAtCheckout: 'Nein, ich erstelle eines beim Checkout'
  },
  kit: {
    miniHeader: 'Hier bekommst du alles, was du brauchst, um erfolgreich zu starten.',
    kitHeader: 'Wähle ein Set mit unseren beliebtesten Produkten.',
    startForFree: 'Möchtest du ohne Starter-Set beginnen? Bitte kontaktiere den Kundenservice.',
    contactLabel: 'Kontakt:',
    details: 'Details',
    productsInKit: 'Produkte in diesem Kit:',
    startUpBox: 'Start-Box:',
    totalValue: '({0} Gesamtwert!)',
    selectKitTitle: 'Wählen Sie Ihr Kit',
    selectKitMessage: 'Für Ihr Land sind mehrere Kits verfügbar. Bitte wählen Sie das Kit aus, das Sie kaufen möchten:',
    selectKit: 'Dieses Kit auswählen',
    noProductsAvailable: 'Für das ausgewählte Land sind keine Kit-Produkte verfügbar. Bitte wenden Sie sich für Unterstützung an den Kundenservice.',
    privacyPolicy: 'Datenschutzrichtlinie',
    certification: 'Ich bestätige, dass ich 18 Jahre oder älter bin und die Bedingungen der {consultantAgreementLink} gelesen und akzeptiert habe',
    independentConsultantAgreement: 'Unabhängige Beratervereinbarung'
  },
  terms: {
    checkoutAgreement: 'Mit Klick auf „Jetzt kaufpflichtig bestellen“ akzeptierst du die {termsLink}  und die  {privacyLink} und stimmst der Verarbeitung deiner Daten zur Bestellabwicklung zu',
    agreement: 'Mit einem Klick auf den Button „Jetzt Bestellen“ stimmst du unseren {termsLink}  zu. Bitte informiere dich außerdem über unsere {privacyLink}',
    checkoutTermsOfUse: 'AGB',
    checkoutPrivacyPolicy: 'Datenschutzerklärung',

    termsOfUse: 'ALLGEMEINE GESCHAFTSBEDINGUNGEN',
    privacyPolicy: 'DATENSCHUTZERKLÄRUNG',
    certification: 'Ich bestätige, dass ich 18 Jahre oder älter bin und die Bedingungen der {consultantAgreementLink} gelesen und akzeptiert habe',
    independentConsultantAgreement: 'Unabhängige Beratervereinbarung',
    ethics: 'Ich akzeptiere und habe die H+BH {prohibitedBusinessPracticesLink} und {codeOfEthicsLink} gelesen',
    prohibitedBusinessPractices: 'Verbotene Geschäftspraktiken',
    codeOfEthics: 'Verhaltenskodex',
    prohibitedBusinessPracticesUrl: 'https://pamperedchef.widen.net/s/qlznjrtpjk/prohibited-business-practices-deat',
    codeOfEthicsUrl: 'https://pamperedchef.widen.net/s/kzrsqxx6wm/berkshire-code-of-conduct-deat',
    showMore: 'mehr anzeigen'
  },
  frenchContribution: {
    FrenchContributionHeader: 'Französische Steuerdokumente',
    FrenchContributionSubHeader: 'Laden Sie Ihre steuerbezogenen Dokumente zur Compliance-Überprüfung und -Genehmigung hoch',
    SiretNumber: 'SIRET-Nummer',
    UploadFile: 'Klicken Sie zum Hochladen oder ziehen Sie Ihr Steuerdokument per Drag & Drop',
    MaxFileSize: 'Maximale Dateigröße: 10MB',
    SupportedFormats: 'Unterstütztes Format: Nur PDF',
    SelectedFile: 'Ausgewählte Datei',
    RemoveFile: 'Datei Entfernen',
    Upload: 'Dokument Hochladen',
    Uploading: 'Wird hochgeladen...',
    LoadingDocuments: 'Dokumente werden geladen...',
    PageLoadError: 'Fehler beim Laden des französischen Beitragbereichs',
    SaveError: 'Upload Fehlgeschlagen',
    SaveSuccess: 'Dokument erfolgreich hochgeladen! Ihr Steuerdokument wurde zur Überprüfung eingereicht.',
    TryAgain: 'Erneut Versuchen',
    FileTooLarge: 'Die Dateigröße überschreitet das 10MB-Limit. Bitte wählen Sie eine kleinere Datei.',
    InvalidFileFormat: 'Nur PDF-Dateien werden unterstützt. Bitte wählen Sie ein PDF-Dokument.',
    UnknownError: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
  },
  eventTasks: {
    title: 'Veranstaltungsaufgaben',
    subtitle: 'Akzeptierte Leads',
    loading: 'Leads werden geladen...',
    noLeads: 'Keine akzeptierten Leads gefunden.',
    email: 'E-Mail',
    phone: 'Telefon',
    leadType: 'Lead-Typ',
    source: 'Quelle',
    note: 'Notiz',
    loadingNote: 'Notiz wird geladen...',
    notePlaceholder: 'Fügen Sie eine Notiz zu diesem Lead hinzu...',
    saveNote: 'Notiz speichern',
    created: 'Erstellt',
    assigned: 'Zugewiesen',
    accepted: 'Akzeptiert',
    partyDate: 'Party-Datum',
    theme: 'Thema',
    bestTime: 'Beste Zeit zum Kontaktieren',
    tasks: 'Aufgaben',
    due: 'Fällig',
    registerNewMember: 'Neues Mitglied registrieren',
    joinMyTeam: 'Meinem Team beitreten',
    saveTasks: 'Aufgaben speichern',
    joinMyTeamUrlCopied: '„Mein Team beitreten“-URL wurde in die Zwischenablage kopiert!',
    failedToCopyUrl: 'URL konnte nicht kopiert werden. Bitte versuchen Sie es erneut.',
    failedToLoadLeads: 'Leads konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
    failedToSaveTasks: 'Aufgaben konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    failedToSaveNote: 'Notiz konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    tasksSavedSuccessfullyFor: 'Aufgaben wurden erfolgreich gespeichert für {firstName} {lastName}',
    noteSavedSuccessfullyFor: 'Notiz wurde erfolgreich gespeichert für {firstName} {lastName}',
    errorLoadingNote: 'Notiz konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    coaching: {
      contact: 'Sprechen Sie über die großartigen Vorteile der Chance und teilen Sie Ihre persönliche Geschichte, wie TPC Ihr Leben bereichert hat.',
      email: 'Fügen Sie den folgenden Link in eine E-Mail ein und senden Sie sie an Ihren Recruit\n{fullUrl}\nWeisen Sie darauf hin, dass beim Anmeldeprozess Ihre Berater-ID eingegeben werden soll.',
      followup: 'Rufen Sie den Interessenten an, um sicherzustellen, dass er den Vertrag erhalten hat, und beantworten Sie alle Fragen.',
    },
    taskNames: {
      contact: 'Potentiellen Berater kontaktieren',
      email: 'E-Mail mit dem Anmeldelink an potentiellen Berater senden',
      followup: 'Telefonisches Follow-up mit potentiellem Berater',
    },
  },
  businessDetails: {
    Title: 'Geschäftsdetails',
    ShowChart: 'Diagramm anzeigen',
    ShowGrid: 'Tabelle anzeigen',
    Metrics: 'Metriken',
    ChartTitle: 'Geschäftsmetriken im Zeitverlauf',
    errors: {
      noColumnsFoundInReportDefinition: 'Keine Spalten in der Berichtdefinition gefunden',
      noBatchHistoryFound: 'Keine Batch-Historie gefunden',
      failedToLoadData: 'Daten konnten nicht geladen werden',
    },
  },
  teamIncentiveDetails: {
    Title: 'Team-Anreizdetails',
    NoReportsFound: 'Keine Anreizberichte gefunden',
    SelectIncentive: 'Anreiz',
    SelectPlaceholder: 'Wählen Sie einen Anreizbericht aus...'
  },
  consultantActivity: {
    Title: 'Berateraktivität',
    SelectBatch: 'Batch-Periode auswählen',
    SelectBatchPlaceholder: 'Wählen Sie einen Batch aus...',
    SelectedBatchInfo: 'Ausgewählte Batch-Informationen',
    BatchName: 'Batch-Name',
    BatchNumber: 'Batch-Nummer',
    HistoryDate: 'Verlaufsdatum',
    NoDataAvailable: 'Keine Daten für den ausgewählten Batch verfügbar',
    AdjustmentsTab: 'Anpassungen',
    ActivityTab: 'Aktivität',
    OrdersTab: 'Bestellungen',
    ActivityTabPlaceholder: 'Aktivitätsbericht wird hier angezeigt. Implementierung folgt in Kürze.',
    OrdersTabPlaceholder: 'Bestellungsbericht wird hier angezeigt. Implementierung folgt in Kürze.',
    Metric: 'Metrik',
    Value: 'Wert',
    IncludeTeam: 'Team einbeziehen',
    RemoveTeam: 'Team entfernen'
  },
  ccReport: {
    Filters: 'Filter',
    ApplyFiltersToTableData: 'Filter auf Tabellendaten anwenden',
    NoFilterableColumns: 'Für diesen Bericht sind keine filterbaren Spalten verfügbar.',
    StartDate: 'Startdatum',
    EndDate: 'Enddatum',
    ClearFilters: 'Filter löschen',
    ApplyFilters: 'Filter anwenden',
    IncludeTeam: 'Team einbeziehen',
    RemoveTeam: 'Team entfernen',
    ShowingItems: '{0} - {1} von {2} Elementen',
    NoRecordsAvailable: 'Keine Datensätze verfügbar',
    ExpandAll: 'Alle erweitern',
    CollapseAll: 'Alle reduzieren',
    ExportToExcel: 'Nach Excel exportieren',
    SearchByName: 'Nach Name suchen',
    DataUpdatedAsOf: 'Datenstand: {datetime}',
    DrilldownLoadError: 'Details konnten nicht geladen werden'
  },
    ccConsultantDetail: {
    ConsultantDetails: 'Beraterdetails',
    LoadingDetails: 'Beraterdetails werden geladen...',
    FullName: 'Vollständiger Name',
    Status: 'Status',
    Address: 'Adresse',
    Phone: 'Telefon',
    Email: 'E-Mail',
    Sponsor: 'Sponsor',
    Recruiter: 'Recruiter',
    PersonalGroup: 'Persönliche Gruppe',
    ProfilePhotoAlt: 'Profilfoto',
    NoAddressAvailable: 'Keine Adresse verfügbar',
    NotAvailable: 'N/V',
    Retry: 'Wiederholen',
    BusinessDetails: 'Geschäftsdetails',
    ViewBusinessDetails: 'Geschäftsdetails Anzeigen',
    SearchConsultant: 'Berater Suchen',
    SearchPlaceholder: 'Tippen Sie, um Berater zu suchen...',
    AddBookmark: 'Lesezeichen hinzufügen',
    RemoveBookmark: 'Lesezeichen entfernen',
    Bookmark: 'Lesezeichen',
    BookmarkedConsultants: 'Vorgemerkte Berater',
    NoBookmarkedConsultants: 'Noch keine vorgemerkten Berater'
  },
  eventManagement: {
    AddGuest: 'Gast Hinzufügen',
    AddGuestButton: 'Ausgewählte Gäste Hinzufügen',
    FindGuestError: 'Bitte wählen Sie mindestens einen Gast zum Hinzufügen aus',
    DuplicateGuestError: 'Dieser Gast wurde bereits zur Veranstaltung hinzugefügt',
    AddGuestCancelButton: 'Abbrechen',
    BreadCrumbPage: 'Party',
    CreateOrder: 'Bestellung Erstellen',
    DeleteButton: 'Löschen',
    EmailAddress: 'E-Mail-Adresse',
    EventDate: 'Datum',
    EventID: 'Veranstaltungs-ID',
    EventInfo: 'Veranstaltungsinformationen',
    EventList: 'Startseite',
    EventEndTime: 'Endzeit',
    EventStartTime: 'Startzeit',
    EventStatus: 'Veranstaltungsstatus',
    EventTitle: 'Veranstaltungstitel',
    EventType: 'Veranstaltungstyp',
    EventWhen: 'Wann',
    EventWhere: 'Wo',
    FindContact: 'Kontakt Suchen',
    FirstName: 'Vorname',
    GuestInfo: 'Gästeinformationen',
    GuestName: 'Name',
    GuestRole: 'Rolle',
    Guests: 'Gäste',
    Hostess: 'Gastgeberin',
    HostEmail: 'E-Mail des Gastgebers',
    HostName: 'Name des Gastgebers',
    HostPhoneNumber: 'Telefon des Gastgebers',
    InviteOpened: 'Einladung Geöffnet',
    InviteVisited: 'Einladung Besucht',
    LastName: 'Nachname',
    MakeHost: 'Zum Gastgeber Machen',
    NewContact: 'Neuer Kontakt',
    OrderTotal: 'Gesamt / Fällig',
    PhoneNumber: 'Telefonnummer',
    PlaceOrder: 'Bestellung Aufgeben',
    RSVP: 'RSVP',
    SaveButton: 'Speichern',
    SendEmail: 'E-Mail Senden',
    ViewReceipt: 'Quittung Anzeigen',
    TransferButton: 'Veranstaltung Übertragen',
    SendEmailTo: 'E-Mail Senden An',
    EmailSubject: 'E-Mail-Betreff',
    EmailBody: 'E-Mail-Text',
    Cancel: 'Abbrechen',
    Send: 'Senden',
    // Host Portal Messages
    HostPortalHeader: 'Gastgeber-Portal',
    HostPortalStep1: 'Schritt 1: Gastgeber-Portal konfigurieren',
    HostPortalStep2: 'Schritt 2: Passwort erstellen',
    HostPortalStep3: 'Schritt 3: Einladung senden',
    ChooseTheme: 'Wählen Sie das Thema des Gastgeber-Portals',
    ImagePreview: 'Bildvorschau zum Thema:',
    PasswordPlaceholder: 'Passwort für Gastgeber eingeben (z.B. Cooking Show1)',
    OptionalNote: 'Optionale Notiz:',
    CcMeOnEmails: 'Mich bei allen E-Mails zum Gastgeber-Portal in CC setzen',
    SendEmailButton: 'E-Mail senden',
    SavePortalSettings: 'Portal-Einstellungen speichern',
    ViewHostDashboard: 'Gastgeber-Dashboard Anzeigen',
    HostPortalColumn: 'Gastgeber-Portal',
    ManageHostPortal: 'Verwalten',
    ViewHostPortal: 'Ansehen',
    // Email Editor Messages
    EmailPreview: 'E-Mail-Vorschau',
    To: 'An',
    From: 'Von',
    Regarding: 'Betreff',
    SendInvitation: 'Einladung senden',
    // Success Messages
    PortalSettingsSaved: 'Portal-Einstellungen gespeichert',
    InvitationEmailSent: 'Einladungs-E-Mail gesendet',
    // Default Values
    NoEmailTemplate: 'Keine E-Mail-Vorlage verfügbar',
    // Error Messages
    CopyFailed: 'Kopieren in die Zwischenablage fehlgeschlagen',
    // Validation Messages
    EventDatePastError: 'Das Veranstaltungsdatum darf nicht in der Vergangenheit liegen',
    EventEndTimeBeforeStartError: 'Die Endzeit darf nicht vor der Startzeit liegen',
    InvalidEmailFormat: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    MissingRequiredFields: 'Die folgenden Pflichtfelder fehlen: {fields}',
    CannotCloseEventWithItemsTitle: 'Veranstaltung Kann Nicht Geschlossen Werden',
    CannotCloseEventWithItemsMessage: 'Diese Veranstaltung kann nicht geschlossen werden, da es nicht eingereichte Warenkörbe mit Artikeln gibt. Bitte stellen Sie sicher, dass alle Warenkörbe leer oder eingereicht sind, bevor Sie die Veranstaltung schließen.',
    CannotDeleteEventWithItemsTitle: 'Veranstaltung Kann Nicht Gelöscht Werden',
    CannotDeleteEventWithItemsMessage: 'Diese Veranstaltung kann nicht gelöscht werden, da es nicht eingereichte Warenkörbe mit Artikeln gibt. Bitte stellen Sie sicher, dass alle Warenkörbe leer oder eingereicht sind, bevor Sie die Veranstaltung löschen.',

    CancelEventButton: 'Stornieren',
    CancelEventConfirmTitle: 'Veranstaltung stornieren',

    CancelEventConfirmMessage: 'Sind Sie sicher, dass Sie diese Veranstaltung stornieren möchten? Die Veranstaltung wird schreibgeschützt und ihre Warenkörbe werden deaktiviert.',

    CloseEventButton: 'Abschließen',

    BackButton: 'Zurück',

    CloseEventConfirmTitle: 'Veranstaltung abschließen',

    CloseEventConfirmMessage: 'Sind Sie sicher, dass Sie diese Veranstaltung abschließen möchten? Die Veranstaltung wird schreibgeschützt.',
    // Cart URL Messages
    CartPageUrl: 'Shop-Seiten-URL',
    CartPageUrlUnavailable: 'Die Shop-Seiten-URL ist nicht verfügbar, solange Ihr öffentlicher Shop deaktiviert ist.',
    CopyCartUrl: 'URL Kopieren',
    Copied: 'Kopiert!',
    // Email Messages
    EmailSubjectAndBodyRequired: 'Bitte geben Sie sowohl Betreff als auch Text der E-Mail ein',
    GuestEmailNotAvailable: 'E-Mail-Adresse des Gastes ist nicht verfügbar',
    EmailSentSuccessfully: 'E-Mail erfolgreich gesendet',
    EmailSendFailed: 'E-Mail konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    PleaseCompleteAllFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
  },
  gamificationDifferenceMessage: {
    OrderTotal_FreeShipping: 'Kostenloser Versand ab {totalAmount}',
    PartyOrderTotal_FreeShipping: 'Kostenloser Versand ab {totalAmount}',
    OrderTotal: 'Geben Sie nur {difference} mehr aus, um zusätzliche Rabatte zu erhalten',
  },
  phoneInput: {
    placeholder: 'Telefonnummer eingeben',
    phoneNumber: 'Telefonnummer',
    extension: 'Nebenstelle',
    type: 'Telefontyp',
    home: 'Zuhause',
    cell: 'Mobil',
    work: 'Arbeit',
    other: 'Andere',
    required: 'Telefonnummer ist erforderlich',
    invalid: 'Bitte geben Sie eine gültige Telefonnummer ein',
    country: {
      DE: 'DE',
      AT: 'AT',
      FR: 'FR',
    }
  },
  marketing: {
    optInConfirm: {
      title: 'E-Mail-Bestätigung',
      confirmedMessage: 'Vielen Dank für die Bestätigung Ihres E-Mail-Abonnements.',
      noEmailProvided: 'Keine E-Mail-Adresse angegeben.',
    },
  },
  hostPortalPage: {
    loadingEventDetails: 'Veranstaltungsdetails werden geladen...',
    genericErrorTitle: 'Ups! Etwas ist schiefgelaufen',
    tryAgain: 'Erneut versuchen',
    eventTitleFallback: "{name}s Event",
    eventSubtitle: 'Pampered Chef Veranstaltung',
    eventImageAlt: 'Eventbild {number}',
    descriptionTitle: 'Verwöhne deine Küche diesen Sommer!',
    hostedBy: 'Gastgeber',
    location: 'Ort',
    eventDescription: 'Willkommen zu meinem Pampered Chef Event! Mach mit für eine tolle Zeit mit großartigen Produkten.',
    shopNow: 'Jetzt einkaufen',
    shareThisInvite: 'Diese Einladung teilen',
    shareText: 'SMS',
    shareFacebook: 'Facebook',
    shareEmail: 'E-Mail',
    copy: 'Kopieren',
    starts: 'Beginnt',
    hostingQuestion: 'Bist du Gastgeber der Party?',
    signInToSeeDashboard: 'Anmelden, um dein Dashboard zu sehen',
    inviteLinkCopiedTitle: 'Kopiert',
    inviteLinkCopiedMessage: 'Einladungslink wurde in die Zwischenablage kopiert',
    unknownHost: 'Unbekannter Gastgeber',
    errors: {
      noEventIdProvided: 'Keine Event-ID angegeben',
      eventNotFound: 'Event nicht gefunden',
      loadingEventDetails: 'Fehler beim Laden der Eventdetails',
      copyInviteLinkFailed: 'Einladungslink konnte nicht kopiert werden',
      guestNotFound: 'Gast für dieses Event nicht gefunden',
      loadingGuestDetails: 'Fehler beim Laden der Gastdaten',
      updateStatusFailed: 'Ihre Zusage konnte nicht aktualisiert werden. Bitte erneut versuchen.',
    },
    guestSection: {
      heading: 'Ihre Zusage',
      greeting: 'Hallo {name},',
      currentStatusLabel: 'Ihr aktueller Status:',
      changeStatusLabel: 'Zusage aktualisieren:',
      statusUpdatedTitle: 'Zusage aktualisiert',
      statusUpdatedMessage: 'Danke! Ihre Zusage wurde gespeichert.',
    },
  }
  ,
  kendo: {
    grid: {
      pagerItemsPerPage: 'Elemente pro Seite',
      pagerInfo: '{0} - {1} von {2} Elementen',
      noRecords: 'Keine Datensätze verfügbar',
      noRecordsFound: 'Keine Einträge gefunden',
      noOrdersAvailable: 'Keine Bestellungen verfügbar',
      noPartiesAvailable: 'Keine Kochshows verfügbar',
    },
    upload: {
      select: 'Dateien auswählen',
      dropFilesHere: 'Füge Dateien per drag & drop hier hinzu',
      remove: 'Entfernen',
      invalidFileExtension: 'Dateityp nicht erlaubt.',
      invalidMaxFileSize: 'Datei ist zu groß.',
    },
  },
  countries: {
    germany: 'Deutschland',
    austria: 'Österreich',
    france: 'Frankreich',
    switzerland: 'Schweiz',
    belgium: 'Belgien',
    spain: 'Spanien',
    italy: 'Italien',
    netherlands: 'Niederlande',
    poland: 'Polen',
    unitedKingdom: 'Vereinigtes Königreich',
    ireland: 'Irland',
    portugal: 'Portugal',
    sweden: 'Schweden',
    denmark: 'Dänemark',
    norway: 'Norwegen',
    finland: 'Finnland',
    unitedStates: 'Vereinigte Staaten',
    canada: 'Kanada',
    australia: 'Australien',
    newZealand: 'Neuseeland',
    japan: 'Japan',
    china: 'China',
    brazil: 'Brasilien',
    mexico: 'Mexiko',
    india: 'Indien',
    unknown: 'Unbekannt',
  },
  pagination: {
    previousPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
    goToPage: 'Gehe zu Seite {page}',
    ellipsis: '...',
  },
  hostDashboard: {
    EventDetails: 'Party-Details',
    Welcome: 'Willkommen, {firstName}!',
    WelcomeSubTitle: 'Im Gastgeber-Dashboard können Sie Ihren Party-Erfolg und Ihre Prämien verfolgen.',
    GuestActions: 'Gast-Aktionen',
    CurrentPartyTotal: 'Aktueller Party-Gesamtbetrag',
    CurrentPartyTotalDescription: 'Gesamtumsatz für Ihre aktuelle Party',
    ProductSales: 'Produktverkäufe',
    ProductSalesDescription: 'Gesamte Produktverkäufe ohne Steuern und Versand',
    GuestList: 'Party-Gästeliste',
    InvitationReminder: 'Einladung senden',
    ChangeStatus: 'Status ändern',
    RemoveGuest: 'Gast entfernen',
    EventRewards: 'Meine Prämien',
    AddGuest: "+ Gast",
    ImportGuests: 'Gäste importieren',
    Import: 'Importieren',
    AddGuestButton: 'Hinzufügen',
    AddGuestCancelButton: 'Abbrechen',
    Invited: 'Gäste',
    Attending: 'Bestellungen',
    GuestName: 'Name',
    EmailAddress: 'E-Mail',
    GuestOrderTotal: 'Bestellsumme',
    CodeTextInvitationStatus: 'Status',
    TotalSales: 'Gesamtumsatz',
    OrderStatus: 'Bestellstatus',
    OrderSubmitted: 'Eingereicht',
    OrderPending: 'Ausstehend',
    NoRewardsYet: 'Noch keine Prämien verdient.',
    RewardsGuide: 'Prämien-Leitfaden',
    RewardsPdfUrl: 'https://ttgcommon-180003f.s3.eu-central-1.amazonaws.com/tpc/contentimages/032026_Neues-Gastgeber-Bonusprogramm_DEAT_RE28022026.pdf',
    GuestSales: 'Gäste-Umsatz',
    GuestSalesLeftToReach: 'Gäste-Umsatz fehlen noch bis zur nächsten Prämien-Stufe',
    AllRewardsEarned: 'Sie haben alle Prämien-Stufen erreicht!',
    AboutRewardLevels: 'Über Prämien-Stufen',
    YourRewardsLevel: 'Ihre Prämien-Stufe',
    ShopMyWishList: 'Meine Wunschliste kaufen',
    ShopAll: 'Alle Produkte kaufen',
    EnterPassword: 'Passwort eingeben',
    PasswordRequired: 'Bitte geben Sie das Passwort ein, um auf das Gastgeber-Dashboard zuzugreifen.',
    PasswordPlaceholder: 'Passwort',
    InvalidPassword: 'Ungültiges Passwort. Bitte versuchen Sie es erneut.',
    HostPortalImage1: 'host-a-party-half-price-products.jpg',
    HostPortalImage2: 'de-cons-and-host.jpg',
    HostPortalImage3: 'boxes.jpg',
  },
  earnedDiscountToDescription: {
    Default: "{quantity} - {awardMessage}",
    DiscountedItem: "{awardDescription} ({awardMessage})",
    FreeProduct: "{awardDescription} ({awardMessage})",
    SelectFreeProduct: "{appliedAmount} - {awardMessage}",
  },
  myStory: {
    NoStoryAvailable: 'Derzeit ist keine Geschichte verfügbar.',
  }
}
